var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _g2, _defs, _g3, _g4, _defs2, _g5, _defs3, _g6, _defs4, _g7, _g8, _defs5, _g9, _g10, _polygon7, _polygon8, _path, _defs6, _g11, _defs7, _g12, _g13, _defs8, _g14, _g15, _g16, _defs9, _g17, _g18, _defs10, _g19, _ellipse, _defs11, _g20, _defs12, _g21, _defs13, _g22, _g23, _defs14, _g24, _defs15, _g25, _defs16, _g26, _g27, _defs17, _g28, _defs18, _g29, _g30, _defs19, _g31, _defs20, _g32, _defs21, _g33, _g34, _g35, _g36, _defs22, _g37, _path2, _path3, _path4, _path5, _polygon9, _polygon10, _polygon11, _g38, _g39, _path6, _path7, _path8, _path9, _path10, _path11, _polygon12, _polygon13, _polygon14, _defs23, _g40, _defs24, _g41, _defs25, _g42, _g43, _g44, _g45, _defs26, _g46, _path12, _path13, _path14, _path15, _g47, _defs27, _g48, _defs28, _g49, _g50, _g51, _g52, _defs29, _g53, _path16, _path17, _path18, _path19, _g54, _defs30, _g55, _defs31, _g56, _g57, _g58, _g59, _defs32, _g60, _path20, _path21, _defs33, _g61, _defs34, _g62, _g63, _g64, _g65, _defs35, _g66, _path22, _path23, _defs36, _g67, _defs37, _g68, _g69, _g70, _g71, _defs38, _g72, _circle, _circle2, _g73, _g74, _polygon15, _path24, _polygon16, _defs39, _defs40, _defs41, _polygon17, _polygon18, _polygon19, _g75, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _line, _polygon29, _polygon30, _polygon31, _polygon32, _g76, _g77;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBerkeleytime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1249.2 1243.3",
    xmlSpace: "preserve",
    title: "Welcome to Berkeleytime.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#8A8A8A;}\n\t.st2{font-family:'Inter-Regular';}\n\t.st3{font-size:30px;}\n\t.st4{fill:#FFFFFF;stroke:#A7A9AC;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st5{fill:#E0F3FD;}\n\t.st6{fill:#BDD970;}\n\t.st7{opacity:0.5;}\n\t.st8{enable-background:new    ;}\n\t.st9{fill:#8A9CA6;}\n\t.st10{fill:#AFC4D0;}\n\t.st11{fill:#798992;}\n\t.st12{fill:#899BA5;}\n\t.st13{fill:#ADC2CD;}\n\t.st14{clip-path:url(#SVGID_2_);enable-background:new    ;}\n\t.st15{fill:#98ABB2;}\n\t.st16{fill:#95A7AE;}\n\t.st17{fill:#91A4AA;}\n\t.st18{fill:#BED4DB;}\n\t.st19{clip-path:url(#SVGID_4_);enable-background:new    ;}\n\t.st20{fill:#809196;}\n\t.st21{fill:#84949A;}\n\t.st22{fill:#87989E;}\n\t.st23{fill:#8A9CA2;}\n\t.st24{fill:#8EA0A6;}\n\t.st25{clip-path:url(#SVGID_6_);enable-background:new    ;}\n\t.st26{clip-path:url(#SVGID_8_);enable-background:new    ;}\n\t.st27{fill:#9FB2B8;}\n\t.st28{clip-path:url(#SVGID_10_);enable-background:new    ;}\n\t.st29{fill:#FFFFFF;}\n\t.st30{clip-path:url(#SVGID_12_);enable-background:new    ;}\n\t.st31{fill:#889192;}\n\t.st32{clip-path:url(#SVGID_14_);enable-background:new    ;}\n\t.st33{fill:#ECF7F5;}\n\t.st34{fill:#EAF6F4;}\n\t.st35{fill:#E4F0EE;}\n\t.st36{fill:#E0EBEA;}\n\t.st37{fill:#DCE7E6;}\n\t.st38{fill:#D8E3E2;}\n\t.st39{fill:#D4DFDE;}\n\t.st40{fill:#D0DBDB;}\n\t.st41{fill:#CCD8D7;}\n\t.st42{fill:#C9D4D3;}\n\t.st43{fill:#C5D0CF;}\n\t.st44{fill:#C1CCCC;}\n\t.st45{fill:#BDC8C8;}\n\t.st46{fill:#B9C4C4;}\n\t.st47{fill:#B5C0C0;}\n\t.st48{fill:#B2BCBC;}\n\t.st49{fill:#AEB8B8;}\n\t.st50{fill:#AAB4B4;}\n\t.st51{fill:#A6B0B0;}\n\t.st52{fill:#A2ACAD;}\n\t.st53{fill:#EDF7F5;}\n\t.st54{fill:#9EA8A9;}\n\t.st55{fill:#EEF7F6;}\n\t.st56{fill:#9AA4A5;}\n\t.st57{fill:#EEF8F6;}\n\t.st58{fill:#97A0A1;}\n\t.st59{fill:#EFF8F6;}\n\t.st60{fill:#EFF8F7;}\n\t.st61{fill:#939C9D;}\n\t.st62{fill:#F0F8F7;}\n\t.st63{fill:#8F9899;}\n\t.st64{fill:#F1F9F7;}\n\t.st65{fill:#8C9496;}\n\t.st66{fill:#F2F9F8;}\n\t.st67{fill:#F3FAF8;}\n\t.st68{fill:#F3FAF9;}\n\t.st69{fill:#F4FAF9;}\n\t.st70{fill:#D1DDDC;}\n\t.st71{clip-path:url(#SVGID_16_);enable-background:new    ;}\n\t.st72{fill:#E8F6F9;}\n\t.st73{fill:#8AADCE;}\n\t.st74{fill:#D0E8F4;}\n\t.st75{fill:#BBD9E9;}\n\t.st76{fill:#D0E8F5;}\n\t.st77{fill:none;stroke:#594A42;stroke-miterlimit:10;}\n\t.st78{fill:#A5B3BC;}\n\t.st79{clip-path:url(#SVGID_18_);enable-background:new    ;}\n\t.st80{fill:#A3A3A3;}\n\t.st81{fill:#A8A8A8;}\n\t.st82{fill:#ADADAD;}\n\t.st83{fill:#B3B3B3;}\n\t.st84{fill:#B8B8B8;}\n\t.st85{fill:#9E9E9E;}\n\t.st86{fill:#999999;}\n\t.st87{fill:#DBDBDB;}\n\t.st88{clip-path:url(#SVGID_20_);enable-background:new    ;}\n\t.st89{fill:#858585;}\n\t.st90{fill:#8F8F8F;}\n\t.st91{fill:#949494;}\n\t.st92{clip-path:url(#SVGID_22_);enable-background:new    ;}\n\t.st93{fill:#959EA0;}\n\t.st94{fill:#99A1A3;}\n\t.st95{fill:#9DA5A7;}\n\t.st96{clip-path:url(#SVGID_24_);enable-background:new    ;}\n\t.st97{fill:#929A9C;}\n\t.st98{fill:#8E9698;}\n\t.st99{fill:#8B9295;}\n\t.st100{fill:#878F91;}\n\t.st101{fill:#848B8D;}\n\t.st102{clip-path:url(#SVGID_26_);enable-background:new    ;}\n\t.st103{fill:#C3CCCE;}\n\t.st104{clip-path:url(#SVGID_28_);enable-background:new    ;}\n\t.st105{clip-path:url(#SVGID_30_);enable-background:new    ;}\n\t.st106{clip-path:url(#SVGID_32_);enable-background:new    ;}\n\t.st107{fill:#CDD7D8;}\n\t.st108{clip-path:url(#SVGID_34_);enable-background:new    ;}\n\t.st109{fill:#A0A9AB;}\n\t.st110{fill:#A4ADAE;}\n\t.st111{fill:#A8B0B2;}\n\t.st112{fill:#ABB4B6;}\n\t.st113{fill:#AFB8BA;}\n\t.st114{fill:#B3BBBD;}\n\t.st115{fill:#B6BFC1;}\n\t.st116{fill:#BAC3C4;}\n\t.st117{fill:#BDC6C8;}\n\t.st118{fill:#C1CACB;}\n\t.st119{fill:#C4CECF;}\n\t.st120{fill:#C8D1D2;}\n\t.st121{fill:#CBD5D6;}\n\t.st122{fill:#CFD8D9;}\n\t.st123{fill:#D2DCDD;}\n\t.st124{fill:#D6E0E1;}\n\t.st125{fill:#DCE6E6;}\n\t.st126{fill:#E0E8E9;}\n\t.st127{fill:#E1E9EA;}\n\t.st128{fill:#E3EAEA;}\n\t.st129{fill:#E4EBEB;}\n\t.st130{fill:#E5EBEC;}\n\t.st131{fill:#E5ECEC;}\n\t.st132{fill:#E6ECED;}\n\t.st133{fill:#E7EDED;}\n\t.st134{fill:#E8EEEE;}\n\t.st135{fill:#E9EEEE;}\n\t.st136{fill:#E9EEEF;}\n\t.st137{fill:#EAEFEF;}\n\t.st138{fill:#EBF0F0;}\n\t.st139{clip-path:url(#SVGID_36_);enable-background:new    ;}\n\t.st140{fill:#848B8E;}\n\t.st141{clip-path:url(#SVGID_38_);enable-background:new    ;}\n\t.st142{clip-path:url(#SVGID_40_);enable-background:new    ;}\n\t.st143{fill:#758C8F;}\n\t.st144{clip-path:url(#SVGID_42_);enable-background:new    ;}\n\t.st145{fill:#7E979A;}\n\t.st146{fill:#819B9D;}\n\t.st147{fill:#859EA1;}\n\t.st148{fill:#88A2A5;}\n\t.st149{fill:#8BA6A8;}\n\t.st150{fill:#748B8D;}\n\t.st151{fill:#95B1B4;}\n\t.st152{fill:#B1D2D4;}\n\t.st153{clip-path:url(#SVGID_44_);enable-background:new    ;}\n\t.st154{fill:#7B9396;}\n\t.st155{fill:#789092;}\n\t.st156{fill:#374751;}\n\t.st157{fill:#9CCB3B;}\n\t.st158{fill:#7FB341;}\n\t.st159{fill:#E6E7E8;}\n\t.st160{fill:url(#SVGID_45_);}\n\t.st161{fill:url(#SVGID_46_);}\n\t.st162{fill:url(#SVGID_47_);}\n\t.st163{fill:url(#SVGID_48_);}\n\t.st164{fill:url(#SVGID_49_);}\n\t.st165{fill:url(#SVGID_50_);}\n\t.st166{fill:#F0F8FD;}\n\t.st167{display:none;}\n\t.st168{display:inline;}\n\t.st169{clip-path:url(#SVGID_52_);}\n\t.st170{fill:#F4EA06;}\n\t.st171{fill:#A7A9AC;}\n\t.st172{clip-path:url(#SVGID_54_);enable-background:new    ;}\n\t.st173{clip-path:url(#SVGID_56_);enable-background:new    ;}\n\t.st174{clip-path:url(#SVGID_58_);enable-background:new    ;}\n\t.st175{display:inline;fill:#9D7B2D;}\n\t.st176{clip-path:url(#SVGID_60_);enable-background:new    ;}\n\t.st177{clip-path:url(#SVGID_62_);enable-background:new    ;}\n\t.st178{clip-path:url(#SVGID_64_);enable-background:new    ;}\n\t.st179{fill:none;stroke:#9D7B2D;stroke-width:0.5439;stroke-miterlimit:10;}\n\t.st180{clip-path:url(#SVGID_66_);enable-background:new    ;}\n\t.st181{clip-path:url(#SVGID_68_);enable-background:new    ;}\n\t.st182{clip-path:url(#SVGID_70_);enable-background:new    ;}\n\t.st183{clip-path:url(#SVGID_72_);enable-background:new    ;}\n\t.st184{clip-path:url(#SVGID_74_);enable-background:new    ;}\n\t.st185{clip-path:url(#SVGID_76_);enable-background:new    ;}\n\t.st186{clip-path:url(#SVGID_78_);enable-background:new    ;}\n\t.st187{clip-path:url(#SVGID_80_);enable-background:new    ;}\n\t.st188{clip-path:url(#SVGID_82_);enable-background:new    ;}\n\t.st189{fill:#E5F5FD;stroke:#D4E4EE;stroke-width:2;stroke-miterlimit:10;}\n\t.st190{fill:#D4E4EE;}\n\t.st191{fill:#FFFFFF;stroke:#A8A9AC;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st192{fill:#9DACD8;}\n\t.st193{fill:#E6E7E8;stroke:#A8A9AC;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st194{fill:#414042;}\n\t.st195{fill:none;stroke:#76C044;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st196{fill:#27A7DF;}\n\t.st197{fill:none;stroke:#A8A9AC;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st198{fill:#73BF44;}\n\t.st199{fill:#7BC142;}\n\t.st200{fill:#76C044;}\n\t.st201{fill:#E0DAD9;}\n\t.st202{fill:none;stroke:#E6E7E8;stroke-miterlimit:10;}\n\t.st203{fill:#F5F6F6;}\n\t.st204{clip-path:url(#SVGID_84_);}\n\t.st205{clip-path:url(#SVGID_86_);}\n\t.st206{fill:none;stroke:#E0DAD9;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st207{fill:#74C044;}\n\t.st208{fill:#4979BD;}\n\t.st209{fill:#4F53A4;}\n\t.st210{fill:#91C7EC;}\n\t.st211{fill:#FAA31C;}\n\t.st212{fill:#DD6026;}\n\t.st213{fill:#EBEAEF;}\n\t.st214{fill:#DEE9F6;}\n\t.st215{fill:#FDD648;}\n\t.st216{fill:#F26A58;}\n\t.st217{fill:none;stroke:#EE5688;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st218{fill:none;stroke:#629FD6;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st219{fill:none;stroke:#7BC143;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st220{fill:#639FD5;}\n\t.st221{fill:#E0DAD9;stroke:#E0DAD9;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st222{fill:#EE5688;}\n\t.st223{fill:#7BC144;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "everything"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cred"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 1163.6,
    transform: "matrix(0.8715 -0.4905 0.4905 0.8715 -510.2888 408.5895)",
    className: "st0",
    width: 201.7,
    height: 28.5
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8715 -0.4905 0.4905 0.8715 439.9433 1233.4202)",
    className: "st1 st3",
    fontFamily: "DM Sans, Arial, Helvetica, sans-serif"
  }, "\xA9 Janet Xu "))), /*#__PURE__*/React.createElement("g", {
    id: "big-phone"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "759.1,469.1 25.3,877.6 418.2,1166.1 1151.9,757.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "25.3,877.6 25.3,916.4 418.2,1204.8 418.2,1166.1  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.2,1166.1 418.2,1204.8 1151.9,791.3 1151.9,757.8  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "758.2,505.8 573,608.7 700.5,703.5 882.1,599.3  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "555.4,633.5 186.3,831.4 376.5,971 741,765.6  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "916.1,621 727.4,724.6 906.7,855 1095.3,751.5  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "192.8,1023.5 194.1,1012.4 196.8,1017.4 196.4,1021.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "188.2,1024.2 189.5,1013.1 194.1,1012.4 192.8,1023.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "189.6,1022.3 188.2,1024.2 189.5,1013.1 190.1,1018.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "256.8,1071.5 192.8,1023.5 196.4,1021.3 256.2,1066.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "252.2,1072.2 188.2,1024.2 192.8,1023.5 256.8,1071.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "249.5,1067.1 252.2,1072.2 188.2,1024.2 189.6,1022.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "194.1,1012.4 258.1,1060.3 256.7,1062.3 196.8,1017.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "258.1,1060.3 256.8,1071.5 256.2,1066.1 256.7,1062.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "190.1,1018.5 189.5,1013.1 253.5,1061.1 249.9,1063.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "253.5,1061.1 258.1,1060.3 256.8,1071.5 252.2,1072.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "189.5,1013.1 194.1,1012.4 258.1,1060.3 253.5,1061.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "249.9,1063.3 253.5,1061.1 252.2,1072.2 249.5,1067.1  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st8",
    d: "M1054.5,823.4l2.3,1.2c-1.2-0.6-2.6-0.9-4.1-0.7l-2.3-1.2 C1051.9,822.4,1053.3,822.7,1054.5,823.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1052.7,823.9l-2.3-1.2c0.9-0.1,1.8-0.1,2.7,0.1l2.3,1.2C1054.5,823.8,1053.6,823.8,1052.7,823.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1055.4,824l-2.3-1.2c0.4,0.1,0.8,0.3,1.2,0.4l2.3,1.2C1056.2,824.3,1055.8,824.1,1055.4,824"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1056.6,824.5l-2.3-1.2c0.1,0,0.2,0.1,0.2,0.1l2.3,1.2C1056.7,824.5,1056.6,824.5,1056.6,824.5"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1052.7,823.9c4.3-0.6,7.7,2.6,7.7,7.2c0,4.6-3.5,8.8-7.7,9.4c-4.3,0.6-7.7-2.6-7.7-7.2 C1045,828.7,1048.4,824.5,1052.7,823.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    className: "st8",
    d: "M1048.5,839.8l-2.3-1.2c-2.2-1.2-3.6-3.6-3.6-6.5c0-4.6,3.5-8.8,7.7-9.4l2.3,1.2 c-4.3,0.6-7.7,4.8-7.7,9.4C1045,836.2,1046.4,838.6,1048.5,839.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1048.5,839.8l-2.3-1.2c-2.2-1.2-3.6-3.6-3.6-6.5c0-1.1,0.2-2.2,0.6-3.3l2.3,1.2 c-0.4,1-0.6,2.1-0.6,3.3C1045,836.2,1046.4,838.6,1048.5,839.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1045.6,830l-2.3-1.2c0.2-0.4,0.4-0.9,0.6-1.3l2.3,1.2C1045.9,829.1,1045.7,829.6,1045.6,830"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1046.2,828.7l-2.3-1.2c0.2-0.4,0.4-0.7,0.6-1l2.3,1.2C1046.6,828,1046.3,828.4,1046.2,828.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1046.8,827.7l-2.3-1.2c0.2-0.3,0.4-0.6,0.7-0.9l2.3,1.2C1047.2,827.1,1047,827.4,1046.8,827.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1047.5,826.8l-2.3-1.2c0.2-0.3,0.5-0.5,0.8-0.8l2.3,1.2C1048,826.3,1047.7,826.5,1047.5,826.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1048.3,826l-2.3-1.2c0.3-0.3,0.6-0.5,0.9-0.7l2.3,1.2C1048.9,825.5,1048.6,825.8,1048.3,826"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1049.2,825.3l-2.3-1.2c0.4-0.3,0.8-0.5,1.3-0.7l2.3,1.2C1050,824.8,1049.6,825,1049.2,825.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1050.4,824.6l-2.3-1.2c0.7-0.3,1.5-0.6,2.3-0.7l2.3,1.2C1051.9,824,1051.2,824.2,1050.4,824.6"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    className: "st8",
    d: "M1003.8,851.4l4.6,2.5c-0.7-0.4-1.6-0.6-2.5-0.4l-4.6-2.5 C1002.2,850.8,1003,851,1003.8,851.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1005.8,853.4l-4.6-2.5c0.6-0.1,1.1,0,1.6,0.1l4.6,2.5C1006.9,853.4,1006.4,853.3,1005.8,853.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1007.5,853.5l-4.6-2.5c0.3,0.1,0.5,0.2,0.7,0.3l4.6,2.5C1008,853.7,1007.7,853.6,1007.5,853.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1008.2,853.8l-4.6-2.5c0,0,0.1,0,0.1,0.1l4.6,2.5C1008.3,853.8,1008.2,853.8,1008.2,853.8"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    className: "st8",
    d: "M1004.2,854l-4.6-2.5c0.5-0.3,1.1-0.5,1.7-0.6l4.6,2.5 C1005.3,853.5,1004.7,853.7,1004.2,854z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1004.2,854l-4.6-2.5c0.1-0.1,0.2-0.1,0.3-0.2l4.6,2.5C1004.4,853.9,1004.3,853.9,1004.2,854"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1004.5,853.8l-4.6-2.5c0.4-0.2,0.9-0.3,1.4-0.4l4.6,2.5C1005.4,853.5,1004.9,853.6,1004.5,853.8"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "912.7,905.2 908.1,902.7 999.6,851.5 1004.2,854  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    className: "st8",
    d: "M911.8,914.2l-4.6-2.5c-0.8-0.4-1.5-1.2-1.8-2.2c-0.9-2.4,0.3-5.5,2.7-6.9l4.6,2.5 c-2.4,1.3-3.6,4.4-2.7,6.9C910.4,913,911,913.8,911.8,914.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M911.8,914.2l-4.6-2.5c-0.8-0.4-1.5-1.2-1.8-2.2c-0.4-1.2-0.4-2.5,0.1-3.7l4.6,2.5 c-0.4,1.2-0.5,2.6-0.1,3.7C910.4,913,911,913.8,911.8,914.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M910.1,908.3l-4.6-2.5c0.1-0.3,0.2-0.5,0.4-0.8l4.6,2.5C910.3,907.8,910.2,908,910.1,908.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M910.4,907.5l-4.6-2.5c0.1-0.2,0.2-0.4,0.4-0.6l4.6,2.5C910.7,907.1,910.5,907.3,910.4,907.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M910.8,906.9l-4.6-2.5c0.1-0.2,0.3-0.4,0.4-0.5l4.6,2.5C911.1,906.5,910.9,906.7,910.8,906.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M911.2,906.4l-4.6-2.5c0.1-0.2,0.3-0.3,0.5-0.5l4.6,2.5C911.5,906.1,911.4,906.2,911.2,906.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M911.7,905.9l-4.6-2.5c0.2-0.2,0.4-0.3,0.6-0.4l4.6,2.5C912,905.6,911.9,905.8,911.7,905.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M912.2,905.5l-4.6-2.5c0.1-0.1,0.3-0.2,0.4-0.3l4.6,2.5C912.5,905.3,912.4,905.4,912.2,905.5"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1005.8,853.4c1.9-0.3,3.6,0.7,4.3,2.6c0.9,2.4-0.3,5.5-2.7,6.9L916,914.1c-0.5,0.3-1.1,0.5-1.7,0.6 c-1.9,0.3-3.6-0.7-4.3-2.6c-0.9-2.4,0.3-5.5,2.7-6.9l91.5-51.2C1004.7,853.7,1005.3,853.5,1005.8,853.4z"
  })))))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "774.3,794.1 631.3,872.4 751.8,950.2 884.9,873.1  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "598.4,894.1 412.3,999.5 524.7,1082 716.8,973.6  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M108.8,479.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "seal"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    className: "st8",
    d: "M288.4,1019.5c3.8-0.9,5.2-1.5,5.7-1.7c0.8-0.3,1.8-0.7,2.5-1.1 c0.7-0.4,1.7-0.8,2.4-1.2c0.7-0.4,1.6-0.9,2.3-1.3c0.7-0.4,1.6-1,2.2-1.5c1.1-0.9,2.6-2.2,3.7-3.2c0,0,1.6-1.5,3.3-3.7 C305.6,1012.2,297.9,1017.3,288.4,1019.5c-11.6,2.7-23.1,0.4-31.2-5.2c1.2,0.8,2.8,1.7,4,2.4c0.9,0.5,2.1,1,3,1.3 c3.6,1.4,7.2,2,7.5,2c1.6,0.2,3.7,0.4,5.3,0.5c0.8,0.1,2,0,2.8,0c2-0.1,2-0.1,5.6-0.5 C286.4,1019.9,287.6,1019.7,288.4,1019.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M288.4,1019.5c12-3,17.8-8.5,21.9-13.6C305.6,1012.2,297.9,1017.3,288.4,1019.5 c-11.6,2.7-23.1,0.4-31.2-5.2c3,1.9,6.7,4.3,14.5,5.8C276.8,1021,283.3,1020.8,288.4,1019.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    className: "st8",
    d: "M303.8,966c-1.2-0.8-2.8-1.7-4-2.4c-0.9-0.5-2.1-1-3.1-1.4c-3.6-1.4-7.2-2-7.6-2 c-2.6-0.4-8.6-1.3-16.6,0.6c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c4.5,16.2-8.3,33.1-28.5,37.8 c-20.2,4.7-40.2-4.7-44.7-20.9c-4.5-16.2,8.3-33.1,28.5-37.8c0,0.1,0.3,1,0.4,1c-0.8,0.2-2,0.5-2.8,0.7 c-0.9,0.3-2.1,0.6-2.9,1c-0.8,0.3-1.8,0.7-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2c-0.7,0.4-1.6,0.9-2.3,1.3 c-0.7,0.4-1.6,1-2.2,1.5c-1.1,0.9-2.6,2.2-3.7,3.2c0,0-1.6,1.5-3.3,3.7c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3C312.7,974.4,308.9,969.5,303.8,966z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M303.8,966c-9.4-6-19-7.6-31.2-5.2c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9 c4.5,16.2-8.3,33.1-28.5,37.8c-20.2,4.7-40.2-4.7-44.7-20.9c-4.5-16.2,8.3-33.1,28.5-37.8c0,0.1,0.3,1,0.4,1 c-8.3,2.2-15.3,5.4-21.9,13.6c-4.8,6.5-6.7,14.2-4.6,21.7c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3 C312.7,974.4,308.9,969.5,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c2.6,9.4-0.6,19.1-7.7,26.4c0.1-0.1,0.1-0.1,0.2-0.2 c8.2-9.2,6.4-14.5,6.4-14.5c-0.1,0-0.3-0.1-1.1,1.7c-1.1,2.5-4.1,9.1-11,14.3c-7.1,5.4-13.4,7.1-19,8.6 c-0.6,0.2-2.3,0.6-2.4,0.8c-0.1,0.1,0,0.4,0.1,0.5c0.4,0.3,7.4,0.9,16.3-3.6c-3.1,1.6-6.6,2.9-10.3,3.7 c-20.2,4.7-40.2-4.7-44.7-20.9c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c2,7.3,0.5,14.7-3.5,21.1c0.2-0.3,0.4-0.8,0.6-1.1c3.6-7,2.3-10,2.3-10 c-0.1-0.1-0.3-0.2-0.4-0.2c-0.5,0.2-0.6,1.2-0.8,1.7c-2.5,7.1-6.7,12.7-12.4,16.8c-2.3,1.7-7.8,5.6-18.3,8 c-2.6,0.6-3.4,0.9-3.3,1.2c0,0.2,3.5,1.5,12.3-1.3c-1.6,0.6-3.3,1.1-5,1.5c-20.2,4.7-40.2-4.7-44.7-20.9 c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c1.5,5.6,1,11.2-1.1,16.4c0-0.1,0.1-0.3,0.2-0.4c2-5.8,0.6-8.6,0.5-8.7 c-0.4-0.1-0.6,0.6-0.9,1.8c-1.9,7.8-5.7,13.6-12.4,18.9c-7.4,5.8-16.4,7.8-20.3,8.6c-1.1,0.2-3,0.7-3,1 c0,0.3,2.5,1.4,9.4-0.1c-0.3,0.1-0.7,0.2-1,0.2c-20.2,4.7-40.2-4.7-44.7-20.9c-4.5-16.2,8.3-33.1,28.5-37.8 C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c1.1,3.8,1.2,7.7,0.4,11.5c0-0.2,0.1-0.5,0.1-0.7 c0.5-4.7-0.8-6.4-0.8-6.4c-0.1-0.1-0.3,0-0.4,0c-0.4,0.4-0.3,1.3-0.4,1.9c-0.4,2.9-1.4,11.8-10.2,19.7 c-8.6,7.6-18.5,9.7-21.8,10.4c-3.7,0.8-4.6,1-4.8,1.2c-0.1,0.1-0.2,0.3-0.1,0.5c0,0,1.3,1,6.9,0.3c-19.3,3.3-37.7-6-42-21.4 c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c0.6,2.1,0.9,4.1,0.9,6.2c0-0.2,0-0.4,0-0.5c-0.4-3.6-1.6-4.6-1.6-4.6 c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.1-0.2,1.2-0.2,2.3c0,9-3,15.8-10.1,22.6c-5.5,5.3-13.7,8.9-24.3,10.8 c-2,0.4-3.7,0.7-3.8,1.1c-0.1,0.5,1.1,1.1,4.8,0.9c-18,1.7-34.5-7.3-38.5-21.9c-4.5-16.2,8.3-33.1,28.5-37.8 C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c20.2-4.7,40.2,4.7,44.7,20.9c0.1,0.2,0.1,0.4,0.1,0.6c0-0.1-0.1-0.2-0.1-0.3c-0.9-2.4-1.8-2.9-2-2.7 c-0.3,0.2-0.2,0.9,0.1,2.9c1.7,11.3-3.3,19.2-7.8,23.8c-6.6,6.8-15.4,11-27.1,12.7c-4.2,0.6-4.3,1-4.4,1.1 c-0.2,0.6,1.4,1,3,1c-16.6,0.3-31.3-8.5-35.1-22.1c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c18.8-4.3,30.7-20.1,26.5-35.3c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3 c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4C274.6,960.4,273.4,960.5,272.6,960.7 c-0.1,0-0.3-0.9-0.4-1c18-4.2,35.9,2.8,42.7,15.9c0-0.1-0.1-0.1-0.1-0.2c-0.7-0.9-1-1-1.2-1c-0.1,0-0.3,0.2-0.3,0.3 c-0.1,0.3,0.3,1.6,0.6,2.4c3.9,13.2-1.4,22.2-6.6,27.5c-10.1,10.3-22.7,12-28,12.7c-4.3,0.6-5.3,0.7-5.3,1.3 c0,0,0,0.5,1.4,0.7c-15.1-0.9-28.1-9.4-31.5-22c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c8.6-2,15.7-6.3,20.5-11.9c-0.3,0.3-0.7,0.8-1,1.1c-5.7,5.6-13.8,11.5-30.6,12.9 c-2.8,0.2-5.6,0.6-5.3,1.3c0,0.1,0.2,0.1,0.2,0.2c-13.5-2-24.6-10-27.8-21.6c-4.5-16.2,8.3-33.1,28.5-37.8 C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c5.4-1.2,10.2-3.4,14.3-6.3c-0.6,0.4-1.3,0.9-1.9,1.3c-2.2,1.3-6.7,3.9-12.3,5.3 c-6.6,1.6-13.5,1.3-20.2,2.6c-11.7-2.8-21-10.4-23.8-20.9c-4.5-16.2,8.3-33.1,28.5-37.8 C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c4-0.9,7.7-2.4,10.9-4.2c-0.4,0.2-1,0.5-1.4,0.8c-17.1,8.3-33.8,5-34,5 c-9.6-3.5-17-10.5-19.5-19.6c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c2.9-0.7,5.7-1.6,8.2-2.8c-0.5,0.2-1.2,0.5-1.7,0.8c-19.4,7.6-35.5,1.6-35.6,1.6 c-7.3-3.8-12.8-9.9-14.9-17.5c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c2-0.5,3.9-1,5.7-1.7c-0.7,0.3-1.7,0.6-2.4,0.9c-18.2,5.6-32.3,0.7-37.3-2.7 c-4.9-3.7-8.5-8.6-10.1-14.5c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c1.1-0.3,2.2-0.6,3.3-0.9c-0.8,0.2-1.8,0.5-2.6,0.8c-12.4,3.3-30,2.2-39.4-7.8 c-2.5-2.9-4.4-6.3-5.4-10c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.2,15.2,22.9,23.9,41.7,19.5c0.3-0.1,0.6-0.1,0.9-0.2c-0.3,0.1-0.6,0.2-0.9,0.2c-19,4.3-36.5-1.6-42.7-14.4 c-0.5-1.1-0.9-2.3-1.3-3.6c-4.5-16.2,8.3-33.1,28.5-37.8C272.2,959.8,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c4.1,14.8,21.9,23.4,40.2,19.9c-0.6,0.1-1.3,0.3-1.9,0.4c-22.8,3.4-41.4-8-41.5-25.4c0.1-10.8,7.3-21.2,18.7-27.1 c4-2,7.2-3,9.3-3.5c0.4-0.1,1.1-0.6,1.5-0.3C272.4,960.2,272.5,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c3.9,14.1,20.4,22.6,37.8,20.3c0,0,0,0,0,0c-31.6,4.3-51.5-19.7-34.9-42.1c1.9-2.5,9.2-11.1,23.4-14.1 C272.4,960.4,272.6,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c3.7,13.5,18.8,21.8,35.3,20.5c-0.1,0-0.3,0-0.5,0c-31.4,2.2-48.7-23.8-29.8-44.7c3.5-3.9,10.1-9.1,21.3-11.6 C272.5,960.5,272.6,960.8,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c15.6-3.6,31.1,1.2,39.4,11c0,0,0,0-0.1,0 c-0.1,0-0.2-0.1-0.2-0.1c-0.6,0.1,0,1.4,0.9,3.2c1.8,3.8,6.5,14-1.3,26.2C314.8,994.1,316.2,987.1,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c3.5,12.8,17.3,21,32.9,20.6c-0.4,0-0.9,0-1.3,0c-32.4-0.3-43.3-27.6-25.9-45.2c5.6-5.6,12.1-9.2,20.7-11.1 C272.5,960.6,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c13.2-3,26.3-0.1,35.1,6.8c0,0,0,0,0.1,0.1 c4.7,7,10.1,14.9,6.9,26.2C315.4,988.7,315.4,984.5,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c3.3,12.1,15.9,20.1,30.3,20.6c-0.6,0-1.5-0.1-2.1-0.1c-31.9-2.8-39.3-31-20.1-47.2c1.9-1.6,7.9-6.6,18.2-8.9 C272.5,960.6,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c10.8-2.5,21.5-1,29.8,3.4 c0.1,0,0.1,0.1,0.2,0.1c1.4,1,14.1,9.9,12.7,25.7C315.3,986.1,315.1,983.1,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c8.3-1.9,16.6-1.5,23.8,0.9 c0.1,0,0.3,0.1,0.4,0.1c0.2,0.1,17.9,7.2,18.7,25.1C315.1,984,314.8,982.1,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c3.1,11.3,14.4,19.1,27.7,20.4c-0.7-0.1-1.7-0.2-2.4-0.2c-28.4-3.9-36.9-31.5-15-48.4c6.2-4.8,13.6-6.6,16.1-7.2 C272.5,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c5.8-1.4,11.7-1.5,17.1-0.7 c0.2,0,0.4,0.1,0.6,0.1c0.9,0.2,21.8,4.8,24.9,23.9C314.7,982.1,314.5,981.2,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M283.1,1017.7c0.2-0.2,1.5-0.6,3.8-1.3c2.3-0.7,9.4-2.7,15.8-7.4c6.8-5,9.5-10.1,11.2-13.2 c0.5-0.9,0.9-1.7,1.1-1.7c0.8,0,0.3,6.8-7.1,14c-10.7,10.3-24.8,10.8-25,9.8C283,1017.9,283.1,1017.8,283.1,1017.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c2.9,10.6,12.9,18,25,20.1c-0.7-0.1-1.6-0.3-2.4-0.4c-27.9-6-33.3-34.3-9.5-49.7c3.7-2.4,8.2-4.2,13.3-5.4 C272.6,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M314.3,980.2c-1.6-5.8-5.4-10.7-10.5-14.3c-0.6-0.4-1.4-0.9-2-1.3c-0.9-0.5-2-1.1-2.9-1.5l-2.2-1 c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c3.2-0.7,6.4-1.1,9.5-1.2c0.3,0,0.6,0,0.9,0 c8.9,0.2,26.9,5.1,31.7,22C314.3,980.5,314.3,980.4,314.3,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M284,1017.6c0.2-0.3,1.4-0.6,3.7-1.3c0,0,1.7-0.5,2.7-0.9c1.9-0.7,7-2.5,12-6.1 c6-4.3,8.9-8.6,11.1-12.4c0.8-1.4,1.1-1.4,1.1-1.4c0,0,0.1,0,0.1,0.1c0.4,0.5-1,8.5-10.4,15.4c-8.2,6.1-17,7.3-19.8,6.9 c-0.2,0-0.6,0-0.7-0.2C283.9,1017.7,284,1017.7,284,1017.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c2.7,9.7,11.3,16.8,22.1,19.5c-0.1,0-0.2,0-0.2-0.1c-29.9-7.8-30-37.3-7.5-50.1C263.4,963.7,266.9,962,272.6,960.7 C272.6,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M285.1,1017.3c0.4-0.2,1.7-0.7,2.8-1c6-1.9,11.1-4.3,14.9-7.2c5.2-3.9,7.6-7.2,10-10.7 c0.7-1,1-1.5,1.2-1.5c0.9,0.1-1.5,8.2-9.8,14.2c-10,7.2-19.1,7.1-19.5,6.6c0,0-0.1-0.1,0-0.2 C284.9,1017.4,285,1017.4,285.1,1017.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c-0.1,0-0.3-0.9-0.4-1c0.2,0,0.4-0.1,0.6-0.1c0.4-0.1,0.8-0.2,1.2-0.2c20.2-3.2,35.4,7.4,39.6,18.9 C311.8,973.3,308.3,969.1,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c2.4,8.8,9.7,15.4,19.1,18.6c0,0-0.1,0-0.2-0.1c-28.5-10-25.6-39-2.1-50.4C264.8,963.2,268,961.8,272.6,960.7 C272.6,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M285.8,1017.2c0.4-0.3,1.2-0.5,1.7-0.7c2.4-0.8,9.6-3.1,15.4-7.4c1.7-1.3,5.6-4.2,9.5-9.8 c0,0,1-1.5,1.3-1.4c1,0.4-3.4,11.4-15.9,16.8c-7.5,3.3-12.1,2.9-12.1,2.6C285.6,1017.3,285.7,1017.2,285.8,1017.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.2-0.6-0.3-0.9c0.3-0.1,0.7-0.1,0.9-0.2c20.1-3.3,34.4,5.9,39.5,16.5 C310.8,972.1,307.7,968.7,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M286.5,1017c0.2-0.2,1-0.5,3.3-1.3c3.3-1.2,8.2-3.1,13-6.6c1.2-0.9,4.9-3.6,8.5-8.4 c0.8-1.1,1.4-1.9,1.7-1.7c0.8,0.5-6,14.2-21.3,17.8c-3,0.7-5.3,0.8-5.4,0.5C286.4,1017.2,286.5,1017.1,286.5,1017"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c2.1,7.7,8,13.8,15.7,17.3c-0.6-0.3-1.5-0.7-2.1-1c-23.6-12.1-17.9-42.4,9.5-50.6C269.2,961.6,271.2,961.1,272.6,960.7 C272.6,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M287.3,1016.9c0.1-0.1,0.2-0.2,3.3-1.3c6.1-2.3,10.1-4.7,12.3-6.4c1.8-1.3,4.7-3.5,8.3-8 c0.5-0.6,1.2-1.4,1.3-1.2c1.7,1.7-11.1,17.1-24.5,17.3c-0.3,0-0.9,0.1-1-0.1C287.1,1017,287.2,1016.9,287.3,1016.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.2-0.4-0.3-0.7c0.2,0,0.4-0.1,0.5-0.1c20.2-3.4,33.5,5.5,38.8,14.2 C309.7,971,307,968.2,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M288,1016.7c0.1-0.1,0.3-0.2,0.5-0.3c2-0.8,4-1.5,5.9-2.4c3.8-1.7,6.4-3.5,8-4.5 c2.5-1.7,5.8-4.7,8.3-7.6c0.4-0.5,1-1.1,1.1-1.1c0,0,0.1,0,0.2,0c0,0-0.7,5-10.2,11.5c-4.3,3-11.3,5-13.6,4.7 c-0.1,0-0.2,0-0.2-0.1C288,1016.9,288,1016.8,288,1016.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M272.6,960.7c-3.7,1-3.7,1-5.7,1.7l-2.5,1.1c-0.7,0.4-1.7,0.8-2.4,1.2l-2.2,1.3 c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5 c1.8,6.4,6.1,11.7,12,15.3c-0.3-0.2-0.8-0.5-1.2-0.7C233.6,994.3,246.4,967,272.6,960.7 C272.6,960.7,272.6,960.7,272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.1-0.3-0.2-0.5c0.6-0.1,1.5-0.3,2.2-0.4c14.9-2.1,28.3,2.5,35.9,12.5 C308.6,969.9,306.4,967.8,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M288.7,1016.6c0.1-0.2,1.5-0.7,2.6-1.2c5.4-2.1,7.9-3.7,11.2-5.9c1.4-0.9,4.5-3.4,7.2-6.4 c0.7-0.8,1.5-1.6,1.7-1.6c0,0,0.1,0,0.1,0.1c0,0-1.2,4.9-9.7,10.6c-5.6,3.7-12.7,5-13.1,4.5 C288.7,1016.7,288.7,1016.6,288.7,1016.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M289.9,1016.1c0.3-0.2,0.7-0.3,1-0.5c3.3-1.3,8-3.4,12-6.4c2.5-1.8,4.7-3.8,6.6-5.8 c0.1-0.1,1.1-1.2,1.3-1.1c0.1,0,0.1,0.1,0.1,0.1c0,0-1.4,4.6-9.2,9.7c-5.3,3.5-11.7,4.8-12.2,4.4c0,0-0.1-0.1-0.1-0.2 C289.5,1016.2,289.7,1016.2,289.9,1016.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.1-0.2-0.2-0.4c0.7-0.1,1.7-0.3,2.4-0.4c13.6-2,26.1,1.9,34.1,10.6 C307.5,968.8,305.7,967.3,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M290.5,1015.9c0.3-0.2,0.7-0.3,2.8-1.3c2.1-0.9,5.3-2.4,9.1-5.1c1.6-1.1,4.3-3.3,6.5-5.5 c0,0,1.2-1.2,1.3-1.1c0.7,0.2-3.6,7-12.1,11c-3.9,1.8-7.6,2.5-7.9,2.3c0,0-0.1-0.1-0.1-0.1 C290.2,1016,290.4,1016,290.5,1015.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M266.9,962.5c-0.7,0.3-2.6,1-4.9,2.3l-2.2,1.3c-0.7,0.4-1.5,1-2.2,1.5l-1.9,1.5 c-0.6,0.5-1.3,1.2-1.9,1.7l-1.6,1.7c-0.5,0.6-1.1,1.3-1.6,1.9c-4.7,6.3-6.6,14-4.5,21.5c1.3,4.6,3.9,8.7,7.5,11.9 c-0.3-0.3-0.8-0.7-1.2-1.1c-16.1-17.1-4.3-38.3,16.6-45.1C268.4,962,267.5,962.2,266.9,962.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.1-0.1-0.1-0.3c0.7-0.1,1.7-0.3,2.5-0.5c8.8-1.3,21.5-0.8,32.4,8.8 C306.2,967.8,305.1,966.8,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M291.2,1015.7c2.9-1.8,6.2-2.8,9.1-4.6c1.4-0.9,4.2-2.7,7.4-5.7c1.3-1.3,1.9-1.8,2.1-1.7 c0.8,0.4-5.9,8.9-15.2,11.6c-3.6,1.1-3.8,0.7-3.8,0.7C290.8,1015.8,291.1,1015.8,291.2,1015.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M291.9,1015.5c0.7-0.5,1.8-0.9,2.6-1.3c4.5-2.1,7.4-4.1,8.5-4.9c1.1-0.8,2.7-2,4.7-3.8 c1-0.9,1.1-1,1.5-1.1c-0.3,3.6-14.2,12.6-17.7,11.4C291.6,1015.7,291.8,1015.5,291.9,1015.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M303.8,966c-1.3-0.9-2.4-1.6-4.8-2.8l-2.2-1c-0.7-0.3-1.7-0.6-2.5-0.9l-2.5-0.7 c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6c0,0-0.1-0.1-0.1-0.2c0.7-0.1,1.7-0.3,2.4-0.5c15.9-2.4,26,3.4,30.6,7.1 C304.9,966.8,304.4,966.4,303.8,966"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M292.6,1015.2c0.5-0.4,1.3-0.7,1.9-1c4.5-2.1,7.2-4,8.5-4.9c1.7-1.2,3.2-2.6,4.8-3.8 c0.2-0.2,0.5-0.4,0.8-0.5c-0.8,3.4-12.7,11.1-16.3,10.5C292.4,1015.4,292.5,1015.3,292.6,1015.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M299,963.2c-3-1.3-3-1.3-4.7-1.8l-2.5-0.7c-0.8-0.2-1.8-0.4-2.6-0.5l-2.6-0.3 c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6l1.2-0.4 c11.2-1.9,20-0.4,28.8,4.8l-2-1.2L299,963.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M293.3,1015c1.2-0.9,2.6-1.3,3.9-2c1.6-0.9,2.9-1.6,5.3-3.2c0.1-0.1,1.8-1.3,2.9-2.2 c2.1-1.7,2.1-1.7,2.6-1.9c-1,3.2-11.4,9.8-15,9.6C293.2,1015.2,293.3,1015,293.3,1015"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M294.2,961.4c-0.8-0.2-2.5-0.8-5.1-1.2l-2.6-0.3c-0.8-0.1-1.9-0.2-2.7-0.2l-2.8,0 c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4c-0.8,0.2-2,0.4-2.8,0.6l0.5-0.2c4.1-0.7,12.6-2.3,23,1.4 C295.5,961.8,294.8,961.5,294.2,961.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M294.1,1014.7c0.1-0.1,1.2-0.6,3.2-1.7c1.7-0.9,3.9-2.3,5.3-3.2c0,0,1.7-1.2,3-2.2 c1.4-1.1,1.5-1.1,1.8-1.2c-1.9,3.7-10.6,8.5-13.5,8.6C293.9,1014.9,294,1014.8,294.1,1014.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M289.2,960.2c-1.2-0.2-2.9-0.4-5.4-0.5l-2.8,0c-0.8,0.1-2,0.1-2.8,0.2l-2.8,0.4 c-0.8,0.2-2,0.4-2.8,0.6l0.1-0.1c3.7-0.7,9.3-1.8,17.4-0.4C289.7,960.3,289.4,960.2,289.2,960.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M294.7,1014.6c0-0.1,0.1-0.1,0.2-0.2c1.6-1,3.4-1.8,5-2.8c1.3-0.8,3.3-2,5.5-3.7 c1-0.8,1.1-0.8,1.4-0.8C304.6,1010.4,297.2,1014.5,294.7,1014.6C294.6,1014.6,294.6,1014.6,294.7,1014.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M295.8,1014c0.4-0.3,0.9-0.6,1.4-0.8c0.8-0.5,1.9-1,2.7-1.5c0,0,2.2-1.4,3.2-2.1 c2.6-1.8,2.6-1.8,2.9-1.8c-1.1,1.7-5.8,5.5-10.3,6.5C295.7,1014.1,295.8,1014,295.8,1014"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M278.2,959.8c-3.8,0.5-3.8,0.5-5.7,0.9l2.6-0.5c1.8-0.3,4.2-0.7,8.4-0.6l-2.8,0L278.2,959.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M296.8,1013.5c0.2-0.2,0.6-0.4,0.8-0.5c0.4-0.2,0.9-0.5,1.2-0.7c0.8-0.5,2.9-1.8,4.3-2.7 c1.4-1,1.6-1,1.8-1c-3.5,3.8-7.8,5.1-8.3,5.2C296.7,1013.7,296.8,1013.6,296.8,1013.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M272.6,960.7l2.7-0.5c0.5-0.1,1.2-0.2,1.7-0.2l-2.8,0.5L272.6,960.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M297.7,1013.2c0-0.1,0.1-0.2,0.2-0.2l5.7-3.6c0.1,0,0.1,0,0.2,0.1 C301.3,1011.9,297.8,1013.2,297.7,1013.2C297.8,1013.2,297.7,1013.2,297.7,1013.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M300.3,1011.7c0.1-0.3,0.5-0.5,0.8-0.5c0.1,0,0.1,0,0.2,0.1c-0.3,0.2-0.7,0.5-1,0.6 C300.3,1011.8,300.2,1011.7,300.3,1011.7"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M272.6,960.7c18.8-4.3,37.5,4.4,41.7,19.5c4.2,15.2-7.7,31-26.5,35.3c-18.8,4.3-37.5-4.4-41.7-19.5 C241.9,980.8,253.8,965,272.6,960.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    className: "st8",
    d: "M317.5,983.2l0.3,2.1c2.5,15.4-9.9,30.8-29.1,35.2c-20.2,4.7-40.2-4.7-44.7-20.9 c-0.2-0.9-0.4-1.7-0.6-2.6l-0.3-2.1c0.1,0.9,0.3,1.7,0.6,2.6c4.5,16.2,24.5,25.6,44.7,20.9 C307.6,1014,320,998.6,317.5,983.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M317.5,983.2l0.3,2.1c0,0.2,0.1,0.3,0.1,0.5l-0.3-2.1C317.6,983.6,317.5,983.4,317.5,983.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M317.6,983.7l0.3,2.1c0.2,1.5,0.3,3,0.2,4.6l-0.3-2.1C317.9,986.8,317.8,985.3,317.6,983.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M317.8,988.3l0.3,2.1c-0.1,2-0.4,3.9-0.9,5.8l-0.3-2.1C317.4,992.2,317.7,990.3,317.8,988.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M316.9,994.1l0.3,2.1c-1.7,6.1-5.7,11.8-11.3,16.3l-0.3-2.1C311.2,1005.9,315.1,1000.2,316.9,994.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M305.5,1010.4l0.3,2.1c-1.7,1.3-3.4,2.5-5.4,3.6l-0.3-2.1C302.1,1012.9,303.9,1011.7,305.5,1010.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M300.2,1013.9l0.3,2.1c-1.5,0.8-3,1.6-4.6,2.2l-0.3-2.1C297.2,1015.5,298.7,1014.8,300.2,1013.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M295.5,1016.2l0.3,2.1c-1.4,0.6-3,1.1-4.5,1.6l-0.3-2.1C292.6,1017.3,294.1,1016.8,295.5,1016.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M291,1017.7l0.3,2.1c-0.9,0.3-1.7,0.5-2.6,0.7c-0.7,0.2-1.4,0.3-2.1,0.4l-0.3-2.1 c0.7-0.1,1.4-0.3,2.1-0.4C289.3,1018.2,290.2,1018,291,1017.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M286.4,1018.9l0.3,2.1c-1.7,0.3-3.4,0.5-5,0.6l-0.3-2.1C283,1019.4,284.7,1019.2,286.4,1018.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M281.3,1019.5l0.3,2.1c-2,0.1-4,0.2-6,0l-0.3-2.1C277.3,1019.7,279.3,1019.7,281.3,1019.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M275.3,1019.6l0.3,2.1c-15.1-0.9-28.1-9.4-31.6-22c-0.2-0.9-0.4-1.7-0.6-2.6l-0.3-2.1 c0.1,0.9,0.3,1.7,0.6,2.6C247.2,1010.2,260.2,1018.7,275.3,1019.6"
  }))))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Campanile"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "798.2,607.2 716.8,652.7 716.5,197.9 793.4,152.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "636.9,155.4 716.5,197.9 793.4,152.3 716.8,118.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "679,139.6 671.2,148.8 703.1,169.1 703.4,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "716.8,652.7 638.7,596 636.9,155.4 716.5,197.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M649.7,63.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "708.7,13.4 670.2,133.8 714.8,163.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "708.7,13.4 757.8,131.7 714.8,163.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "656.4,81.2 681.4,141.3 661.8,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "730.7,163.2 758.6,144.6 755,134.2 726.7,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "656.4,81.2 636.9,142.4 661.8,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "713.5,109.8 740,171 716.6,184.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "713.5,109.8 692.5,172.1 716.6,184.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "768.5,79.4 793.4,139.3 769.9,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "768.5,79.4 747.4,139.3 769.9,153.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M697.2,291.2c0,16.6-9.9,27-22.2,23.2c-12.4-3.8-22.5-20.5-22.5-37.3s10.1-27.1,22.5-23.1 C687.3,257.9,697.2,274.6,697.2,291.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 667.5,
    y1: 262.2,
    x2: 672.8,
    y2: 287.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st77",
    x1: 672.8,
    y1: 287.4,
    x2: 682.8,
    y2: 298.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "769.9,153.3 769.9,166.2 793.4,152.3 793.4,139.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "747.4,139.3 747.4,152.8 769.9,166.2 769.9,153.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "636.9,142.4 636.9,155.4 661.8,169.8 661.8,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "681.4,141.3 681.4,155.4 661.8,169.8 661.8,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "692.5,172.1 692.5,185.1 716.5,197.9 716.6,184.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "716.5,197.9 740,184 740,171 716.6,184.9  "
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "hearst_building"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "1060.8,747.4 980.7,794.3 984.3,674 1060.8,638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "923.8,554.2 846.8,588.5 984.2,674.3 1060.8,637.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "980.7,794.3 844.7,689 846.4,588 984.3,674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "923.2,575.1 998.8,533.4 1060.8,638 984.2,674.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "846.4,588.3 922,546.5 998.8,533.4 923.2,575.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "856.8,697.3 802.2,727.3 900.6,802.4 953.8,770.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "802.2,727.3 801.2,736.3 899.7,811.6 900.7,802.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "900.7,802.5 899.7,811.6 952.8,779.6 953.8,770.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "866.6,699.1 825.7,721.6 899.4,778 939.3,754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "825.7,721.6 824.9,728.4 898.8,784.8 899.5,778  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "899.5,778 898.8,784.8 938.6,760.8 939.3,754  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Hearst_pond"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    className: "st8",
    d: "M632.6,969.4l1.5,8.4c4.1,23-16.1,47.3-48.6,56.5l-1.5-8.4 C616.5,1016.7,636.7,992.5,632.6,969.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M585.5,1034.3l-1.5-8.4c1.1-0.3,2.2-0.7,3.4-1l1.5,8.4C587.7,1033.7,586.6,1034,585.5,1034.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M588.8,1033.3l-1.5-8.4c2.4-0.8,4.7-1.6,7-2.6l1.5,8.4C593.5,1031.7,591.2,1032.5,588.8,1033.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M595.8,1030.7l-1.5-8.4c2.8-1.2,5.5-2.5,8.1-3.9l1.5,8.4C601.3,1028.3,598.6,1029.6,595.8,1030.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M603.9,1026.9l-1.5-8.4c5.6-3.1,10.5-6.6,14.7-10.5l1.5,8.4C614.4,1020.3,609.4,1023.8,603.9,1026.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M618.6,1016.4l-1.5-8.4c0.8-0.8,1.6-1.5,2.3-2.3l1.5,8.4C620.2,1014.8,619.4,1015.6,618.6,1016.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M620.9,1014.1l-1.5-8.4c4-4.1,7.2-8.6,9.5-13.2l1.5,8.4C628.1,1005.5,624.9,1009.9,620.9,1014.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M630.4,1000.8l-1.5-8.4c1.1-2.3,2-4.6,2.7-6.9l1.5,8.4C632.4,996.3,631.5,998.6,630.4,1000.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M633.1,994l-1.5-8.4c0.6-1.9,1-3.8,1.2-5.7l1.5,8.4C634.1,990.1,633.7,992.1,633.1,994"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M634.3,988.2l-1.5-8.4c0.2-1.7,0.3-3.5,0.3-5.2l1.5,8.4C634.6,984.7,634.5,986.5,634.3,988.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M634.6,983l-1.5-8.4c0-1.7-0.2-3.3-0.5-5l1.5,8.4C634.4,979.6,634.6,981.3,634.6,983"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M634.1,978l-1.5-8.4c0-0.1,0-0.1,0-0.2l1.5,8.4C634.1,977.9,634.1,977.9,634.1,978"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M584,1026c-35.9,10.2-73.4-1.8-83.6-26.7c-10.2-25,10.6-53.5,46.5-63.7s73.4,1.8,83.6,26.7 C640.7,987.3,619.9,1015.8,584,1026z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    className: "st8",
    d: "M499.8,1000.4l-1.5-8.4c0.4,2.4,1.1,4.8,2.1,7.1c10.2,25,47.7,36.9,83.6,26.7l1.5,8.4 c-35.9,10.2-73.4-1.8-83.6-26.7C500.9,1005.2,500.2,1002.8,499.8,1000.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M499.8,1000.4l-1.5-8.4c0.4,2.4,1.1,4.8,2.1,7.1c6.4,15.5,23.2,26,43.7,29.3l1.5,8.4 c-20.5-3.3-37.4-13.8-43.7-29.3C500.9,1005.2,500.2,1002.8,499.8,1000.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.6,1036.9l-1.5-8.4c3,0.5,6.1,0.8,9.2,1l1.5,8.4C551.6,1037.7,548.5,1037.4,545.6,1036.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M554.7,1037.8l-1.5-8.4c2.5,0.1,5,0.2,7.5,0.1l1.5,8.4C559.7,1038,557.2,1038,554.7,1037.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M562.3,1037.9l-1.5-8.4c2.3-0.1,4.6-0.2,6.9-0.5l1.5,8.4C566.8,1037.7,564.5,1037.9,562.3,1037.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M569.1,1037.5l-1.5-8.4c2.2-0.2,4.3-0.5,6.5-0.9l1.5,8.4C573.5,1036.9,571.3,1037.2,569.1,1037.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M575.6,1036.6l-1.5-8.4c2.2-0.4,4.3-0.8,6.5-1.4l1.5,8.4C580,1035.7,577.8,1036.2,575.6,1036.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M582.1,1035.2l-1.5-8.4c1.1-0.3,2.2-0.6,3.3-0.9l1.5,8.4C584.3,1034.6,583.2,1034.9,582.1,1035.2"
  }))))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9774 -0.2112 0.2112 0.9774 -194.3735 141.3616)",
    className: "st76",
    cx: 564.6,
    cy: 980.6,
    rx: 58.7,
    ry: 40.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    className: "st8",
    d: "M552.7,994l-2.3-1.2c4.2,2.3,9.2,3.3,14.6,2.5l2.3,1.2 C561.9,997.3,556.9,996.3,552.7,994z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M552.7,994l-2.3-1.2c0.3,0.1,0.6,0.3,0.8,0.4l2.3,1.2C553.2,994.3,553,994.1,552.7,994"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M553.5,994.4l-2.3-1.2c1.4,0.7,2.8,1.2,4.3,1.6l2.3,1.2C556.3,995.6,554.9,995.1,553.5,994.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M557.8,996l-2.3-1.2c2.9,0.8,6.1,0.9,9.4,0.5l2.3,1.2C563.9,997,560.8,996.8,557.8,996"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    className: "st8",
    d: "M579.7,938.8l2.3,1.2c7.6,4.2,12.7,12.7,12.7,23.1c0,16.3-12.3,31.2-27.4,33.3l-2.3-1.2 c15.1-2.1,27.3-17.1,27.4-33.3C592.4,951.5,587.3,943,579.7,938.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M567.3,996.5l-2.3-1.2c2.8-0.4,5.4-1.2,8-2.4l2.3,1.2C572.7,995.3,570,996.1,567.3,996.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M575.2,994.1l-2.3-1.2c1.5-0.7,3-1.6,4.4-2.6l2.3,1.2C578.2,992.5,576.8,993.4,575.2,994.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M579.7,991.6l-2.3-1.2c1.2-0.8,2.3-1.7,3.3-2.6l2.3,1.2C581.9,989.9,580.8,990.8,579.7,991.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M583,988.9l-2.3-1.2c1-0.9,1.9-1.8,2.8-2.8l2.3,1.2C584.9,987.1,583.9,988.1,583,988.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M585.8,986.1l-2.3-1.2c0.9-1,1.7-2,2.5-3.1l2.3,1.2C587.5,984.1,586.6,985.1,585.8,986.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M588.2,983l-2.3-1.2c0.8-1.2,1.6-2.4,2.2-3.6l2.3,1.2C589.8,980.6,589,981.8,588.2,983"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M590.5,979.4l-2.3-1.2c0.8-1.5,1.5-3,2.1-4.6l2.3,1.2C591.9,976.3,591.3,977.9,590.5,979.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M592.5,974.8l-2.3-1.2c1.3-3.7,2.1-7.6,2.1-11.6c0-10.5-5.1-19-12.7-23.1l2.3,1.2 c7.6,4.2,12.7,12.7,12.7,23.1C594.6,967.2,593.9,971.1,592.5,974.8"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    className: "st8",
    d: "M580.6,937l2.3,1.2c-4.5-2.4-9.8-3.5-15.5-2.7l-2.3-1.2 C570.8,933.6,576.1,934.6,580.6,937z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M567.4,935.6l-2.3-1.2c3.5-0.5,6.9-0.3,10,0.5l2.3,1.2C574.3,935.3,570.9,935.1,567.4,935.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M577.4,936.1l-2.3-1.2c1.6,0.4,3.1,1,4.6,1.7l2.3,1.2C580.5,937.1,579,936.5,577.4,936.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M582,937.8l-2.3-1.2c0.3,0.1,0.6,0.3,0.9,0.5l2.3,1.2C582.6,938.1,582.3,938,582,937.8"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M567.4,935.6c16.1-2.3,29.1,10,29,27.3c0,17.3-13.1,33.2-29.2,35.5c-16,2.3-29.1-10-29-27.3 C538.2,953.8,551.3,937.9,567.4,935.6z M567.3,996.5c15.1-2.1,27.3-17.1,27.4-33.3c0-16.3-12.2-27.8-27.3-25.7 c-15.1,2.1-27.3,17.1-27.4,33.3C540,987.1,552.2,998.6,567.3,996.5"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    className: "st8",
    d: "M551.7,995.8l-2.3-1.2c-8.1-4.4-13.5-13.5-13.5-24.6c0-17.3,13.1-33.2,29.2-35.5l2.3,1.2 c-16,2.3-29.1,18.2-29.2,35.5C538.2,982.3,543.6,991.3,551.7,995.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M551.7,995.8l-2.3-1.2c-8.1-4.4-13.5-13.5-13.5-24.6c0-4.3,0.8-8.4,2.2-12.3l2.3,1.2 c-1.4,3.9-2.2,8.1-2.2,12.3C538.2,982.3,543.6,991.3,551.7,995.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M540.4,958.8l-2.3-1.2c0.6-1.7,1.4-3.3,2.2-4.9l2.3,1.2C541.8,955.4,541.1,957.1,540.4,958.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M542.6,953.9l-2.3-1.2c0.7-1.3,1.5-2.6,2.4-3.9l2.3,1.2C544.2,951.2,543.4,952.5,542.6,953.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M545,950l-2.3-1.2c0.8-1.2,1.7-2.3,2.6-3.3l2.3,1.2C546.7,947.7,545.8,948.9,545,950"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M547.7,946.7l-2.3-1.2c0.9-1.1,1.9-2.1,3-3l2.3,1.2C549.6,944.6,548.6,945.6,547.7,946.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M550.6,943.7l-2.3-1.2c1.1-1,2.3-1.9,3.5-2.8l2.3,1.2C552.9,941.7,551.8,942.7,550.6,943.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M554.2,940.9l-2.3-1.2c1.5-1,3.1-2,4.7-2.7l2.3,1.2C557.2,938.9,555.7,939.8,554.2,940.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M558.9,938.2l-2.3-1.2c2.7-1.3,5.5-2.1,8.5-2.6l2.3,1.2C564.4,936,561.6,936.9,558.9,938.2"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    className: "st8",
    d: "M596.7,983.2l-2.7,3.5c2.1-2.8,2.1-7.2-0.5-12.7c-5.5-11.6-20.8-23.7-34-27 c-7-1.7-12.1-0.6-14.5,2.5l2.7-3.5c2.4-3.2,7.5-4.3,14.5-2.5c13.2,3.2,28.5,15.3,34,27C598.8,976,598.8,980.4,596.7,983.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M596.7,983.2l-2.7,3.5c1.7-2.3,2.1-5.7,0.7-9.8l2.7-3.5C598.8,977.5,598.4,980.9,596.7,983.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M597.4,973.4l-2.7,3.5c-0.3-0.9-0.7-1.9-1.2-2.9c-0.1-0.3-0.3-0.6-0.4-0.8l2.7-3.5 c0.1,0.3,0.3,0.6,0.4,0.8C596.7,971.5,597.1,972.5,597.4,973.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M595.8,969.7l-2.7,3.5c-0.6-1.1-1.2-2.2-1.9-3.3l2.7-3.5C594.6,967.5,595.3,968.6,595.8,969.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M593.9,966.4l-2.7,3.5c-0.7-1.1-1.5-2.1-2.3-3.1l2.7-3.5C592.5,964.3,593.2,965.4,593.9,966.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M591.7,963.3l-2.7,3.5c-0.9-1.1-1.8-2.2-2.8-3.3l2.7-3.5C589.8,961.1,590.8,962.2,591.7,963.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M588.8,960l-2.7,3.5c-1.2-1.3-2.5-2.6-3.9-3.8l2.7-3.5C586.3,957.5,587.6,958.7,588.8,960"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M585,956.3l-2.7,3.5c-5.7-5.1-12.5-9.3-19.1-11.6l2.7-3.5C572.5,947,579.3,951.2,585,956.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M565.9,944.6l-2.7,3.5c-1.2-0.4-2.4-0.8-3.6-1.1c-0.3-0.1-0.5-0.1-0.8-0.2l2.7-3.5 c0.3,0.1,0.5,0.1,0.8,0.2C563.5,943.9,564.7,944.2,565.9,944.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M561.5,943.4l-2.7,3.5c-1.2-0.3-2.4-0.4-3.4-0.5l2.7-3.5C559.1,942.9,560.3,943.1,561.5,943.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M558,942.8l-2.7,3.5c-1-0.1-2-0.1-3,0l2.7-3.5C556,942.7,557,942.7,558,942.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M555.1,942.8l-2.7,3.5c-1,0.1-1.9,0.2-2.7,0.4l2.7-3.5C553.2,943,554.1,942.9,555.1,942.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M552.4,943.2l-2.7,3.5c-1,0.3-1.9,0.7-2.7,1.1l2.7-3.5C550.5,943.9,551.4,943.5,552.4,943.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M549.7,944.4l-2.7,3.5c-0.8,0.5-1.4,1.1-1.9,1.7l2.7-3.5C548.3,945.4,549,944.8,549.7,944.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    className: "st8",
    d: "M598.3,984.4l-2.7,3.5c-2.5,3.4-7.9,4.5-15.4,2.7c-14.1-3.4-30.3-16.3-36.2-28.7 c-2.8-5.8-2.7-10.5-0.5-13.5l2.7-3.5c-2.3,3-2.3,7.7,0.5,13.5c5.9,12.4,22.1,25.3,36.2,28.7 C590.4,988.9,595.8,987.7,598.3,984.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M598.3,984.4l-2.7,3.5c-0.5,0.7-1.2,1.3-2,1.9l2.7-3.5C597.1,985.7,597.8,985.1,598.3,984.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M596.3,986.2l-2.7,3.5c-0.8,0.5-1.8,0.9-2.8,1.2l2.7-3.5C594.5,987.2,595.5,986.8,596.3,986.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M593.5,987.5l-2.7,3.5c-0.9,0.2-1.8,0.4-2.9,0.5l2.7-3.5C591.6,987.9,592.6,987.7,593.5,987.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M590.6,987.9l-2.7,3.5c-1,0.1-2,0-3.1,0l2.7-3.5C588.5,988,589.6,988,590.6,987.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M587.4,987.9l-2.7,3.5c-1.2-0.1-2.4-0.3-3.7-0.6l2.7-3.5C585,987.6,586.3,987.8,587.4,987.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M583.7,987.3l-2.7,3.5c-0.3-0.1-0.6-0.1-0.9-0.2c-1.3-0.3-2.6-0.7-3.9-1.2l2.7-3.5 c1.3,0.5,2.6,0.8,3.9,1.2C583.2,987.2,583.5,987.2,583.7,987.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M579,985.9l-2.7,3.5c-7-2.5-14.3-7-20.3-12.4l2.7-3.5C564.8,979,572,983.5,579,985.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M558.7,973.6l-2.7,3.5c-1.4-1.3-2.8-2.6-4.1-4l2.7-3.5C555.9,970.9,557.3,972.3,558.7,973.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M554.6,969.6l-2.7,3.5c-1.1-1.1-2.1-2.3-3-3.5l2.7-3.5C552.5,967.3,553.5,968.4,554.6,969.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M551.6,966.1l-2.7,3.5c-0.9-1.1-1.7-2.2-2.4-3.3l2.7-3.5C549.9,963.9,550.7,965,551.6,966.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M549.2,962.8l-2.7,3.5c-0.8-1.2-1.4-2.3-2-3.5l2.7-3.5C547.7,960.4,548.4,961.6,549.2,962.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M547.1,959.3l-2.7,3.5c-0.2-0.3-0.3-0.6-0.4-0.9c-0.5-1.1-0.9-2.1-1.2-3.1l2.7-3.5 c0.3,1,0.7,2,1.2,3.1C546.8,958.7,547,959,547.1,959.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M545.5,955.3l-2.7,3.5c-1.4-4.4-1.1-8,0.8-10.4l2.7-3.5C544.4,947.3,544,950.9,545.5,955.3"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M561.6,942.2c14.1,3.4,30.3,16.3,36.2,28.7s-0.8,19.7-14.9,16.2c-14.1-3.4-30.3-16.3-36.2-28.7 C540.8,946,547.5,938.7,561.6,942.2z M582.2,985.7c13.2,3.2,19.5-3.6,14-15.2c-5.5-11.6-20.8-23.7-34-27s-19.5,3.6-14,15.2 C553.8,970.4,569,982.5,582.2,985.7"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    className: "st8",
    d: "M533.2,993.2l-3.3-3.6c-0.3-0.3-0.4-0.8-0.3-1.5c0.6-3.3,6.1-10.6,14.7-19.1 c5.7-5.6,12-10.9,17.6-15l3.3,3.6c-5.6,4-11.9,9.3-17.6,15c-8.6,8.5-14.1,15.8-14.7,19.1 C532.8,992.4,532.9,992.9,533.2,993.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M561.9,954.1l3.3,3.6c-0.2,0.1-0.4,0.3-0.6,0.4l-3.3-3.6C561.5,954.4,561.7,954.3,561.9,954.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M561.4,954.5l3.3,3.6c-0.4,0.3-0.7,0.5-1.1,0.8l-3.3-3.6C560.6,955,561,954.8,561.4,954.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M560.3,955.3l3.3,3.6c-0.3,0.3-0.7,0.5-1,0.8l-3.3-3.6C559.6,955.8,560,955.6,560.3,955.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M559.3,956.1l3.3,3.6c-0.3,0.2-0.7,0.5-1,0.7l-3.3-3.6C558.6,956.6,558.9,956.3,559.3,956.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M558.3,956.8l3.3,3.6c-0.3,0.2-0.6,0.5-0.9,0.7l-3.3-3.6C557.7,957.3,558,957.1,558.3,956.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M557.3,957.6l3.3,3.6c-0.3,0.2-0.6,0.5-0.9,0.7l-3.3-3.6C556.7,958.1,557,957.8,557.3,957.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M556.4,958.3l3.3,3.6c-0.3,0.2-0.6,0.5-0.9,0.7l-3.3-3.6C555.8,958.8,556.1,958.5,556.4,958.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M555.5,959l3.3,3.6c-0.3,0.2-0.6,0.5-0.9,0.7l-3.3-3.6C555,959.5,555.2,959.3,555.5,959"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M554.7,959.7l3.3,3.6c-0.3,0.2-0.5,0.4-0.8,0.7l-3.3-3.6C554.1,960.2,554.4,959.9,554.7,959.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M553.9,960.4l3.3,3.6c-0.3,0.2-0.5,0.4-0.8,0.6l-3.3-3.6C553.4,960.8,553.6,960.6,553.9,960.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M553.1,961l3.3,3.6c-0.2,0.2-0.5,0.4-0.7,0.6l-3.3-3.6C552.7,961.4,552.9,961.2,553.1,961"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M552.4,961.6l3.3,3.6c-0.2,0.2-0.4,0.4-0.6,0.5l-3.3-3.6C552,962,552.2,961.8,552.4,961.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M551.8,962.1l3.3,3.6c-0.2,0.2-0.4,0.3-0.6,0.5l-3.3-3.6C551.4,962.5,551.6,962.3,551.8,962.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M551.3,962.6l3.3,3.6c-0.2,0.1-0.3,0.3-0.5,0.4l-3.3-3.6C550.9,962.9,551.1,962.8,551.3,962.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M550.7,963.1l3.3,3.6c-0.2,0.1-0.3,0.3-0.5,0.4l-3.3-3.6C550.4,963.4,550.6,963.2,550.7,963.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M550.3,963.5l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C550,963.8,550.1,963.6,550.3,963.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M549.8,963.9l3.3,3.6c-0.1,0.1-0.3,0.2-0.4,0.4l-3.3-3.6C549.6,964.1,549.7,964,549.8,963.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M549.4,964.3l3.3,3.6c-0.1,0.1-0.3,0.2-0.4,0.3l-3.3-3.6C549.2,964.5,549.3,964.4,549.4,964.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M549,964.6l3.3,3.6c-0.1,0.1-0.2,0.2-0.4,0.3l-3.3-3.6C548.8,964.8,548.9,964.7,549,964.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M548.7,964.9l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C548.4,965.2,548.6,965.1,548.7,964.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M548.3,965.3l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C548.1,965.5,548.2,965.4,548.3,965.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M548,965.6l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C547.8,965.8,547.9,965.7,548,965.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M547.7,965.9l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C547.5,966.1,547.6,966,547.7,965.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M547.4,966.2l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C547.1,966.4,547.2,966.3,547.4,966.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M547,966.5l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C546.8,966.7,546.9,966.6,547,966.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M546.7,966.8l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C546.5,967,546.6,966.9,546.7,966.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M546.4,967.1l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C546.2,967.2,546.3,967.1,546.4,967.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M546.1,967.3l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C545.9,967.5,546,967.4,546.1,967.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M545.8,967.7l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C545.6,967.9,545.7,967.8,545.8,967.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M545.5,968l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C545.2,968.2,545.3,968.1,545.5,968"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M545.1,968.3l3.3,3.6c-0.1,0.1-0.3,0.2-0.4,0.4l-3.3-3.6C544.9,968.5,545,968.4,545.1,968.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M544.8,968.7l3.3,3.6c-0.1,0.1-0.2,0.2-0.4,0.4l-3.3-3.6C544.5,968.9,544.6,968.8,544.8,968.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M544.4,969l3.3,3.6c0,0,0,0-0.1,0.1c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6 C544,969.4,544.2,969.2,544.4,969C544.3,969.1,544.4,969,544.4,969"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M543.9,969.5l3.3,3.6c-0.2,0.2-0.4,0.4-0.5,0.5l-3.3-3.6C543.5,969.9,543.7,969.7,543.9,969.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M543.3,970l3.3,3.6c-0.3,0.3-0.7,0.7-1,1l-3.3-3.6C542.7,970.7,543,970.4,543.3,970"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M542.3,971.1l3.3,3.6c-0.3,0.3-0.6,0.6-0.8,0.9l-3.3-3.6C541.8,971.7,542,971.4,542.3,971.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M541.5,971.9l3.3,3.6c-0.3,0.3-0.6,0.7-1,1l-3.3-3.6C540.8,972.6,541.2,972.3,541.5,971.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M540.5,972.9l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.5l-3.3-3.6C540.2,973.3,540.3,973.1,540.5,972.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M540,973.5l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.5l-3.3-3.6C539.7,973.8,539.8,973.7,540,973.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M539.5,974l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C539.3,974.3,539.4,974.1,539.5,974"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M539.1,974.4l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C538.9,974.7,539,974.6,539.1,974.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M538.8,974.8l3.3,3.6c-0.1,0.1-0.2,0.3-0.4,0.4l-3.3-3.6C538.5,975.1,538.6,975,538.8,974.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M538.4,975.2l3.3,3.6c-0.1,0.1-0.2,0.3-0.4,0.4l-3.3-3.6C538.2,975.5,538.3,975.4,538.4,975.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M538,975.6l3.3,3.6c-0.1,0.1-0.2,0.3-0.4,0.4l-3.3-3.6C537.8,975.9,537.9,975.8,538,975.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M537.7,976l3.3,3.6c-0.1,0.1-0.2,0.3-0.4,0.4l-3.3-3.6C537.4,976.3,537.6,976.2,537.7,976"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M537.3,976.5l3.3,3.6c-0.1,0.2-0.3,0.3-0.4,0.5l-3.3-3.6C537,976.8,537.2,976.6,537.3,976.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M536.9,976.9l3.3,3.6c-0.1,0.2-0.3,0.3-0.4,0.5l-3.3-3.6C536.6,977.2,536.8,977.1,536.9,976.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M536.5,977.4l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.6L536,978C536.2,977.8,536.4,977.6,536.5,977.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M536,978l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.6l-3.3-3.6C535.7,978.3,535.9,978.2,536,978"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M535.6,978.5l3.3,3.6c-0.2,0.3-0.4,0.5-0.6,0.8l-3.3-3.6C535.1,979,535.3,978.8,535.6,978.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M534.9,979.3l3.3,3.6c-0.2,0.3-0.5,0.6-0.7,0.9l-3.3-3.6C534.5,979.9,534.7,979.6,534.9,979.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M534.2,980.2l3.3,3.6c-0.3,0.3-0.5,0.7-0.8,1l-3.3-3.6C533.7,980.8,534,980.5,534.2,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M533.5,981.2l3.3,3.6c-0.3,0.3-0.5,0.7-0.7,1l-3.3-3.6C533,981.9,533.2,981.5,533.5,981.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M532.7,982.2l3.3,3.6c-0.2,0.3-0.4,0.6-0.7,0.9l-3.3-3.6C532.3,982.8,532.5,982.5,532.7,982.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M532.1,983.1l3.3,3.6c-0.2,0.3-0.4,0.6-0.5,0.8l-3.3-3.6C531.7,983.7,531.9,983.4,532.1,983.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M531.6,984l3.3,3.6c-0.2,0.3-0.3,0.5-0.4,0.7l-3.3-3.6C531.2,984.5,531.4,984.2,531.6,984"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M531.1,984.7l3.3,3.6c-0.1,0.2-0.3,0.4-0.4,0.7l-3.3-3.6C530.9,985.1,531,984.9,531.1,984.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M530.7,985.3l3.3,3.6c-0.1,0.2-0.2,0.4-0.3,0.6l-3.3-3.6C530.5,985.7,530.6,985.5,530.7,985.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M530.4,985.9l3.3,3.6c-0.1,0.2-0.2,0.4-0.3,0.5l-3.3-3.6C530.3,986.3,530.3,986.1,530.4,985.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M530.2,986.5l3.3,3.6c-0.1,0.2-0.1,0.3-0.2,0.5l-3.3-3.6C530,986.8,530.1,986.6,530.2,986.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M530,986.9l3.3,3.6c-0.1,0.2-0.1,0.3-0.2,0.4l-3.3-3.6C529.9,987.2,529.9,987.1,530,986.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M529.8,987.4l3.3,3.6c0,0.1-0.1,0.3-0.1,0.4l-3.3-3.6C529.7,987.7,529.8,987.5,529.8,987.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M529.7,987.8l3.3,3.6c0,0.1-0.1,0.2-0.1,0.4c0,0,0,0,0,0l-3.3-3.6c0,0,0,0,0,0 C529.6,988,529.7,987.9,529.7,987.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M529.6,988.2l3.3,3.6c0,0.1,0,0.2,0,0.3l-3.3-3.6C529.6,988.4,529.6,988.3,529.6,988.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M529.6,988.5l3.3,3.6c0,0.1,0,0.2,0,0.3l-3.3-3.6C529.6,988.7,529.6,988.6,529.6,988.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M529.6,988.8l3.3,3.6c0,0.1,0,0.2,0,0.3l-3.3-3.6C529.6,989,529.6,988.9,529.6,988.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M529.6,989.1l3.3,3.6c0,0.1,0,0.2,0.1,0.2l-3.3-3.6C529.7,989.2,529.6,989.2,529.6,989.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M529.7,989.3l3.3,3.6c0,0.1,0.1,0.2,0.1,0.2l-3.3-3.6C529.8,989.5,529.7,989.4,529.7,989.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M529.8,989.5l3.3,3.6c0,0,0,0,0.1,0.1L529.8,989.5C529.9,989.6,529.8,989.6,529.8,989.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    className: "st8",
    d: "M575.3,948.3l3.3,3.6c-0.3-0.3-0.7-0.4-1.2-0.4c-2.2,0-6.5,2.3-12.1,6.3l-3.3-3.6 c5.6-4,9.9-6.2,12.1-6.3C574.6,947.8,575,948,575.3,948.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M575.3,948.3l3.3,3.6c-0.3-0.3-0.7-0.4-1.2-0.4c-1.5,0-4.1,1.1-7.4,3.1l-3.3-3.6 c3.3-2,5.8-3.1,7.4-3.1C574.6,947.8,575,948,575.3,948.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M566.7,951l3.3,3.6c-0.5,0.3-1.1,0.7-1.6,1l-3.3-3.6C565.6,951.6,566.2,951.3,566.7,951"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M565.1,952l3.3,3.6c-0.4,0.3-0.9,0.6-1.3,0.9l-3.3-3.6C564.2,952.6,564.6,952.3,565.1,952"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M563.7,952.9l3.3,3.6c-0.4,0.3-0.8,0.6-1.2,0.8l-3.3-3.6C562.9,953.4,563.3,953.1,563.7,952.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M562.5,953.7l3.3,3.6c-0.2,0.1-0.4,0.3-0.6,0.4l-3.3-3.6C562.1,954,562.3,953.9,562.5,953.7"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M543.8,969.1c6.1-6,12.8-11.7,18.7-15.9c6-4.3,10.6-6.6,12.9-6.7c1.3,0,1.8,0.7,1.6,2 c-0.6,3.5-6.4,11.3-15.6,20.3c-6.1,6-12.8,11.7-18.7,15.9c-6,4.3-10.6,6.6-12.9,6.7c-1.3,0-1.8-0.7-1.6-2 C528.7,985.9,534.6,978.1,543.8,969.1z M561.9,954.1c-5.6,4-11.9,9.3-17.6,15c-8.6,8.5-14.1,15.8-14.7,19.1 c-0.2,1.2,0.3,1.9,1.5,1.9c2.2,0,6.5-2.3,12.1-6.3c5.6-4,11.9-9.3,17.6-14.9c8.6-8.5,14.1-15.8,14.7-19.1 c0.2-1.2-0.3-1.9-1.5-1.9C571.8,947.9,567.5,950.1,561.9,954.1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    className: "st8",
    d: "M576.8,946.9l3.3,3.6c0.3,0.3,0.4,0.9,0.3,1.6c-0.6,3.5-6.4,11.3-15.6,20.3 c-6.1,6-12.8,11.7-18.7,15.9c-6,4.3-10.6,6.6-12.9,6.7c-0.6,0-1-0.1-1.3-0.4l-3.3-3.6c0.3,0.3,0.7,0.4,1.3,0.4 c2.4,0,6.9-2.4,12.9-6.7c6-4.3,12.6-9.9,18.7-15.9c9.2-9,15-16.8,15.6-20.3C577.1,947.8,577.1,947.2,576.8,946.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "st141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M576.8,946.9l3.3,3.6c0,0,0,0.1,0.1,0.1L576.8,946.9C576.8,947,576.8,946.9,576.8,946.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M576.8,947l3.3,3.6c0.1,0.1,0.1,0.1,0.1,0.2l-3.3-3.6C576.9,947.1,576.9,947.1,576.8,947"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M577,947.2l3.3,3.6c0,0.1,0.1,0.2,0.1,0.3l-3.3-3.6C577,947.4,577,947.3,577,947.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M577,947.5l3.3,3.6c0,0.1,0,0.2,0,0.3l-3.3-3.6C577.1,947.7,577.1,947.6,577,947.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M577.1,947.8l3.3,3.6c0,0.1,0,0.2,0,0.3l-3.3-3.6C577.1,948,577.1,947.9,577.1,947.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M577.1,948.1l3.3,3.6c0,0.1,0,0.2,0,0.4l-3.3-3.6C577.1,948.3,577.1,948.2,577.1,948.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M577,948.5l3.3,3.6c0,0,0,0,0,0c0,0.1,0,0.3-0.1,0.4l-3.3-3.6C577,948.7,577,948.6,577,948.5 C577,948.5,577,948.5,577,948.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M576.9,948.9l3.3,3.6c0,0.1-0.1,0.3-0.1,0.4l-3.3-3.6C576.9,949.1,576.9,949,576.9,948.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M576.8,949.3l3.3,3.6c0,0.2-0.1,0.3-0.2,0.5l-3.3-3.6C576.7,949.6,576.8,949.4,576.8,949.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M576.7,949.8l3.3,3.6c-0.1,0.2-0.1,0.3-0.2,0.5l-3.3-3.6C576.5,950.1,576.6,949.9,576.7,949.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M576.4,950.3l3.3,3.6c-0.1,0.2-0.2,0.4-0.3,0.6l-3.3-3.6C576.3,950.6,576.4,950.5,576.4,950.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M576.2,950.8l3.3,3.6c-0.1,0.2-0.2,0.4-0.3,0.6l-3.3-3.6C576,951.2,576.1,951,576.2,950.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M575.8,951.5l3.3,3.6c-0.1,0.2-0.3,0.5-0.4,0.7l-3.3-3.6C575.6,951.9,575.7,951.7,575.8,951.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M575.4,952.2l3.3,3.6c-0.1,0.3-0.3,0.5-0.5,0.8l-3.3-3.6C575.1,952.7,575.3,952.4,575.4,952.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M575,952.9l3.3,3.6c-0.2,0.3-0.4,0.6-0.6,0.9l-3.3-3.6C574.6,953.5,574.8,953.2,575,952.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M574.4,953.8l3.3,3.6c-0.2,0.3-0.4,0.7-0.7,1l-3.3-3.6C574,954.5,574.2,954.1,574.4,953.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M573.7,954.8l3.3,3.6c-0.3,0.4-0.5,0.7-0.8,1.1l-3.3-3.6C573.2,955.5,573.5,955.2,573.7,954.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M572.9,955.9l3.3,3.6c-0.3,0.3-0.5,0.7-0.8,1.1l-3.3-3.6C572.4,956.6,572.7,956.3,572.9,955.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M572.1,957l3.3,3.6c-0.2,0.3-0.5,0.6-0.7,0.9l-3.3-3.6C571.6,957.6,571.9,957.3,572.1,957"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M571.4,957.9l3.3,3.6c-0.2,0.3-0.4,0.5-0.7,0.8l-3.3-3.6C570.9,958.4,571.2,958.2,571.4,957.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M570.7,958.7l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.6l-3.3-3.6C570.4,959.1,570.5,958.9,570.7,958.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M570.2,959.3l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.6l-3.3-3.6C569.9,959.7,570,959.5,570.2,959.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M569.7,959.9l3.3,3.6c-0.1,0.2-0.3,0.3-0.4,0.5l-3.3-3.6C569.4,960.3,569.6,960.1,569.7,959.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M569.3,960.4l3.3,3.6c-0.1,0.2-0.3,0.3-0.4,0.5l-3.3-3.6C569,960.8,569.1,960.6,569.3,960.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M568.8,960.9l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C568.6,961.2,568.7,961.1,568.8,960.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M568.5,961.4l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C568.2,961.7,568.3,961.5,568.5,961.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M568.1,961.8l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C567.8,962.1,567.9,961.9,568.1,961.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M567.7,962.2l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C567.4,962.5,567.6,962.4,567.7,962.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M567.3,962.7l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C567,962.9,567.2,962.8,567.3,962.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M566.9,963.1l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C566.6,963.4,566.8,963.2,566.9,963.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M566.5,963.5l3.3,3.6c-0.2,0.2-0.3,0.4-0.5,0.6l-3.3-3.6C566.1,963.9,566.3,963.7,566.5,963.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M566,964.1l3.3,3.6c-0.2,0.2-0.4,0.4-0.5,0.6l-3.3-3.6C565.6,964.5,565.8,964.3,566,964.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M565.4,964.7l3.3,3.6c-0.3,0.4-0.7,0.7-1,1.1l-3.3-3.6C564.8,965.4,565.1,965,565.4,964.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M564.4,965.7l3.3,3.6c-0.3,0.3-0.6,0.6-0.9,0.9l-3.3-3.6C563.8,966.4,564.1,966,564.4,965.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M563.5,966.7l3.3,3.6c-0.4,0.4-0.7,0.7-1.1,1.1l-3.3-3.6C562.8,967.4,563.2,967,563.5,966.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M562.4,967.8l3.3,3.6c-0.2,0.2-0.4,0.4-0.6,0.6l-3.3-3.6C562,968.1,562.2,967.9,562.4,967.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M561.9,968.3l3.3,3.6c-0.2,0.2-0.3,0.3-0.5,0.5c0,0,0,0-0.1,0.1l-3.3-3.6c0,0,0,0,0.1-0.1 C561.5,968.6,561.7,968.5,561.9,968.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M561.3,968.9l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C561.1,969.1,561.2,969,561.3,968.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M560.9,969.2l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C560.7,969.5,560.8,969.4,560.9,969.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M560.5,969.6l3.3,3.6c-0.1,0.1-0.2,0.2-0.4,0.3l-3.3-3.6C560.3,969.8,560.4,969.7,560.5,969.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M560.2,970l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C560,970.2,560.1,970.1,560.2,970"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M559.8,970.3l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C559.6,970.5,559.7,970.4,559.8,970.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M559.5,970.6l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C559.3,970.8,559.4,970.7,559.5,970.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M559.2,970.9l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C558.9,971.1,559.1,971,559.2,970.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M558.8,971.2l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C558.6,971.5,558.7,971.3,558.8,971.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M558.5,971.6l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C558.3,971.8,558.4,971.7,558.5,971.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M558.2,971.9l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C557.9,972.1,558.1,972,558.2,971.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M557.8,972.2l3.3,3.6c-0.1,0.1-0.2,0.2-0.3,0.3l-3.3-3.6C557.6,972.4,557.7,972.3,557.8,972.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M557.5,972.5l3.3,3.6c-0.1,0.1-0.2,0.2-0.4,0.3l-3.3-3.6C557.2,972.7,557.4,972.6,557.5,972.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M557.1,972.8l3.3,3.6c-0.1,0.1-0.2,0.2-0.4,0.3l-3.3-3.6C556.9,973.1,557,972.9,557.1,972.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M556.8,973.2l3.3,3.6c-0.1,0.1-0.3,0.2-0.4,0.4l-3.3-3.6C556.5,973.4,556.6,973.3,556.8,973.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M556.4,973.5l3.3,3.6c-0.1,0.1-0.3,0.2-0.4,0.4l-3.3-3.6C556.1,973.8,556.2,973.7,556.4,973.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M556,973.9l3.3,3.6c-0.1,0.1-0.3,0.3-0.4,0.4l-3.3-3.6C555.7,974.2,555.8,974,556,973.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M555.5,974.3l3.3,3.6c-0.2,0.1-0.3,0.3-0.5,0.4l-3.3-3.6C555.2,974.6,555.4,974.4,555.5,974.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M555.1,974.7l3.3,3.6c-0.2,0.1-0.3,0.3-0.5,0.4l-3.3-3.6C554.7,975,554.9,974.9,555.1,974.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M554.5,975.2l3.3,3.6c-0.2,0.2-0.4,0.3-0.5,0.5l-3.3-3.6C554.2,975.5,554.4,975.3,554.5,975.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M554,975.6l3.3,3.6c-0.2,0.2-0.4,0.4-0.6,0.5l-3.3-3.6C553.6,976,553.8,975.8,554,975.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M553.4,976.2l3.3,3.6c-0.2,0.2-0.4,0.4-0.7,0.6l-3.3-3.6C553,976.5,553.2,976.4,553.4,976.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M552.7,976.7l3.3,3.6c-0.2,0.2-0.5,0.4-0.7,0.6l-3.3-3.6C552.3,977.1,552.5,976.9,552.7,976.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M552,977.4l3.3,3.6c-0.3,0.2-0.5,0.5-0.8,0.7l-3.3-3.6C551.5,977.8,551.7,977.6,552,977.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M551.2,978l3.3,3.6c-0.3,0.2-0.6,0.5-0.9,0.7l-3.3-3.6C550.6,978.5,550.9,978.3,551.2,978"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M550.4,978.7l3.3,3.6c-0.3,0.3-0.6,0.5-0.9,0.7l-3.3-3.6C549.7,979.2,550.1,979,550.4,978.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M549.4,979.5l3.3,3.6c-0.3,0.3-0.6,0.5-1,0.8l-3.3-3.6C548.8,980,549.1,979.8,549.4,979.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M548.5,980.3l3.3,3.6c-0.3,0.3-0.7,0.5-1,0.8l-3.3-3.6C547.8,980.8,548.2,980.5,548.5,980.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M547.5,981l3.3,3.6c-0.3,0.3-0.7,0.5-1,0.8l-3.3-3.6C546.8,981.6,547.2,981.3,547.5,981"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M546.5,981.8l3.3,3.6c-0.3,0.3-0.7,0.5-1,0.8l-3.3-3.6C545.8,982.4,546.2,982.1,546.5,981.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M545.5,982.6l3.3,3.6c-0.4,0.3-0.7,0.5-1.1,0.8l-3.3-3.6C544.7,983.2,545.1,982.9,545.5,982.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M544.4,983.4l3.3,3.6c-0.4,0.3-0.8,0.6-1.1,0.8l-3.3-3.6C543.6,984,544,983.7,544.4,983.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M543.2,984.3l3.3,3.6c-0.2,0.1-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.3-0.6,0.4l-3.3-3.6 c0.2-0.1,0.4-0.3,0.6-0.4C542.8,984.6,543,984.4,543.2,984.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M542,985.1l3.3,3.6c-0.4,0.3-0.9,0.6-1.3,0.9l-3.3-3.6C541.2,985.8,541.6,985.5,542,985.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M540.7,986l3.3,3.6c-0.5,0.3-1,0.7-1.4,1l-3.3-3.6C539.8,986.7,540.2,986.4,540.7,986"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M539.3,987l3.3,3.6c-0.6,0.4-1.2,0.7-1.7,1.1l-3.3-3.6C538.1,987.7,538.7,987.4,539.3,987"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M537.6,988.1l3.3,3.6c-3.5,2.1-6.2,3.3-7.9,3.3c-0.6,0-1-0.1-1.3-0.4l-3.3-3.6 c0.3,0.3,0.7,0.4,1.3,0.4C531.4,991.4,534.1,990.2,537.6,988.1"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "tree"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    className: "st8",
    d: "M604.4,607.8l0-2.2c0,1,0.5,1.9,1.5,2.7l0,2.2C604.9,609.8,604.4,608.8,604.4,607.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M605.9,608.4l0,2.2c-1-0.8-1.5-1.7-1.5-2.7l0-2.2C604.4,606.7,604.9,607.6,605.9,608.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    className: "st8",
    d: "M637.8,605.5l0,2.2c0,1.1-0.6,2.1-1.8,2.9l0-2.2C637.2,607.6,637.8,606.5,637.8,605.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M637.8,605.5l0,2.2c0,0,0,0,0,0.1L637.8,605.5C637.8,605.5,637.8,605.5,637.8,605.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M637.8,605.5l0,2.2c0,0.2,0,0.4-0.1,0.5l0-2.2C637.8,605.9,637.8,605.7,637.8,605.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M637.7,606.1l0,2.2c0,0.2-0.1,0.4-0.2,0.6l0-2.2C637.6,606.5,637.7,606.3,637.7,606.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M637.6,606.6l0,2.2c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.2C637.3,607.1,637.5,606.9,637.6,606.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M637.1,607.3l0,2.2c-0.3,0.4-0.7,0.7-1.1,1l0-2.2C636.5,608,636.9,607.7,637.1,607.3"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "616.1,615.9 616.1,618.1 605.9,610.5 605.9,608.4  "
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "636,608.3 636,610.5 624.2,618.3 624.2,616.1  "
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M621.6,594c1.6-0.1,3.2,0.4,4.4,1.2l10.2,7.5c2.1,1.6,2,4.1-0.3,5.6l-11.9,7.7c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-10.2-7.5c-2.1-1.6-2-4.1,0.3-5.6l11.9-7.7C619.1,594.4,620.3,594,621.6,594z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    className: "st8",
    d: "M624.2,616.1l0,2.2c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.2 c1.2,0.9,2.8,1.3,4.4,1.2C621.9,617.1,623.1,616.8,624.2,616.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M624.2,616.1l0,2.2c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.2C623.4,616.5,623.8,616.3,624.2,616.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M623,616.7l0,2.2c-0.3,0.1-0.6,0.2-1,0.3l0-2.2C622.4,616.9,622.7,616.8,623,616.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M622.1,617l0,2.2c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.2C621.5,617.1,621.8,617,622.1,617"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M621.3,617.1l0,2.2c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.2c0,0,0,0,0.1,0 C620.8,617.1,621,617.1,621.3,617.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M620.5,617.2l0,2.2c-0.3,0-0.5,0-0.8,0l0-2.2C620,617.2,620.2,617.2,620.5,617.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M619.7,617.1l0,2.2c-0.3,0-0.5,0-0.8-0.1l0-2.2C619.2,617.1,619.5,617.1,619.7,617.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M618.9,617l0,2.2c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.2C618.3,616.9,618.6,617,618.9,617"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M618,616.8l0,2.2c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.2C616.7,616.3,617.3,616.6,618,616.8"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M621.3,609h-1.3c-1.6,0-3-1.3-3-3v-21.4c0-0.8,0.6-1.4,1.4-1.4h4.5c0.8,0,1.4,0.6,1.4,1.4V606 C624.3,607.6,623,609,621.3,609z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M616.3,593c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.6-6.1-6.5-10.9-9.8-14.2c-1.3-1.4-3.5-1.3-4.8,0.1c-3,3.4-6.4,8-9,14.1c-2.8,6.7-7.6,18.2-1.7,27.1 C609.6,589.5,613.1,591.7,616.3,593z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M616.3,577.9c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.7,9.1-7.4c5.9-9.2,1.1-21.1-1.7-28.1 c-1-2.5-2.3-4.8-3.6-6.9c-4-6.2-13-6.1-16.7,0.3c-1.2,2-2.3,4.2-3.3,6.6c-2.8,7-7.6,18.8-1.7,28.1 C609.6,574.2,613.1,576.5,616.3,577.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M616.3,575.2c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.1-4.9-5-8.9-7.7-12c-2.3-2.7-6.5-2.6-8.7,0.1c-2.5,3.1-5,7-7.1,11.9c-2.8,6.7-7.6,18.2-1.7,27.1 C609.6,571.6,613.1,573.8,616.3,575.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "doe_library"
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "616.5,734.9 532.5,671.5 531.6,561.4 620,628  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "618.9,736.1 392.6,863.1 392.6,753.8 620,628  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "392.6,863.1 308.6,799.7 307.7,689.6 392.6,753.8  "
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "662,765.2 439.1,891.3 392.6,852.5 618.9,734.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "392.6,852.6 392.6,863.1 439.1,898.4 439.1,887.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "662,765.2 439.1,887.2 439.1,898.4 662,774.6  "
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "614.6,766.8 457.4,855.7 424.6,828.4 584.2,744.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.6,828.4 424.6,835.8 457.4,860.7 457.4,852.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "614.6,766.8 457.4,852.8 457.4,860.7 614.6,773.4  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 598.8044,
    y1: 692.231,
    x2: 580.1159,
    y2: 692.1614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M609.8,748.8c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3h0c0-39.1,0-78.2,0-117.3h18.5v116.3 C609.9,748,609.9,748.3,609.8,748.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.676,
    y1: 790.9899,
    x2: 392.9875,
    y2: 790.9204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M422.7,847.5c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3h0c0-39.1,0-78.2,0-117.3h18.5v116.3 C422.7,846.8,422.8,847.1,422.7,847.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.5133,
    y1: 754.0174,
    x2: 447.8248,
    y2: 753.9478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M477.6,810.6c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3l0,0c0-39.1,0-78.2,0-117.3h18.5v116.3 C477.6,809.8,477.6,810.1,477.6,810.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.2146,
    y1: 768.5232,
    x2: 420.5261,
    y2: 768.4537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M450.3,825.1c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3h0c0-39.1,0-78.2,0-117.3h18.5V824 C450.3,824.3,450.3,824.6,450.3,825.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.8033,
    y1: 713.8303,
    x2: 525.1149,
    y2: 713.7608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M554.8,770.4c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3h0c0-39.1,0-78.2,0-117.3h18.5v116.3 C554.9,769.6,554.9,769.9,554.8,770.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.7233,
    y1: 699.3293,
    x2: 553.0349,
    y2: 699.2598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0, 0, 0)"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M582.8,755.9c-0.2,3.3-6,4.4-9.3,4.3c-1.7-0.1-5.3-0.6-9.3-4.3l0,0c0-39.1,0-78.2,0-117.3h18.5v116.3 C582.8,755.1,582.8,755.4,582.8,755.9z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "620,628 392.6,753.8 307.7,689.6 531.6,561.4  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "420.9,591.2 307.7,689.6 392.6,753.8 509.3,657.9  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "509.3,657.9 620,628 531.6,561.4 420.9,591.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_51_",
    className: "st8",
    points: "454.7,710.9 500.6,615.1 569.2,647.4 523.2,743.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st169"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "460.2,705.8 456.4,708 456.5,708.4 458.1,707.5 459.3,712.8 459.8,712.5 458.6,707.2  460.3,706.3 460.2,705.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M456.5,708.4l-0.1-0.4l3.8-2.1l0.1,0.4l-1.7,0.9l1.2,5.3l-0.5,0.3l-1.2-5.3L456.5,708.4  M460.4,705.5l-4.2,2.3l0.2,0.9l1.7-0.9l1.2,5.3l0.9-0.5l-1.2-5.3l1.7-0.9L460.4,705.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "466.1,702.5 465.6,702.8 466.1,705.3 463.3,706.9 462.8,704.4 462.3,704.7 463.6,710.4  464.1,710.1 463.4,707.3 466.3,705.8 466.9,708.6 467.4,708.3 466.1,702.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M463.3,706.9l2.8-1.6l-0.6-2.5l0.5-0.3l1.3,5.7l-0.5,0.3l-0.6-2.8l-2.8,1.6l0.6,2.8l-0.5,0.3 l-1.3-5.7l0.5-0.3L463.3,706.9 M466.3,702.2l-0.9,0.5l0.6,2.5l-2.4,1.4l-0.6-2.5l-0.9,0.5l1.4,6l0,0.1l0.9-0.5l-0.6-2.8 l2.4-1.4l0.6,2.8l0.9-0.5l-1.4-6L466.3,702.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "471.5,699.5 468.8,701.1 470.1,706.8 472.9,705.2 472.8,704.8 470.5,706.1 469.9,703.7  472,702.6 471.9,702.1 469.8,703.3 469.4,701.2 471.6,700 471.5,699.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M470.1,706.8l-1.3-5.7l2.7-1.5l0.1,0.4l-2.2,1.2l0.5,2.1l2.1-1.2l0.1,0.4l-2.1,1.2l0.5,2.3l2.4-1.3 l0.1,0.4L470.1,706.8 M471.6,699.2l-3.1,1.7l1.4,6l0,0.1l3.3-1.8l-0.2-0.9l-2.4,1.3l-0.4-1.9l2.1-1.2l-0.2-0.8L470,703 l-0.4-1.7l2.2-1.2L471.6,699.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M480.7,694.4l-0.5,0.3l0.8,3.4c0.3,1.3-0.1,2.3-1,2.8c-0.4,0.2-0.7,0.2-1,0.1c0,0-0.1,0-0.1-0.1 c-0.3-0.2-0.6-0.6-0.7-1.3l-0.8-3.4l-0.5,0.3l0.8,3.4c0.2,0.8,0.5,1.4,1,1.6c0.4,0.2,0.9,0.1,1.4-0.2 c1.3-0.7,1.8-2,1.4-3.6L480.7,694.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M479,701c0.3,0.1,0.6,0.1,1-0.1c0.9-0.5,1.3-1.5,1-2.8l-0.8-3.4l0.5-0.3l0.8,3.4 c0.4,1.6-0.1,2.9-1.4,3.6c-0.6,0.3-1,0.4-1.4,0.2c-0.4-0.2-0.8-0.7-1-1.6l-0.8-3.4l0.5-0.3l0.8,3.4 C478.4,700.3,478.6,700.7,479,701C479,701,479,701,479,701 M480.9,694.1l-0.9,0.5l0.8,3.6c0.2,0.8,0.2,1.9-0.8,2.5 c-0.3,0.2-0.6,0.2-0.8,0.1c0,0-0.1,0-0.1,0c-0.3-0.2-0.5-0.6-0.7-1.2l-0.8-3.6l-0.9,0.5l0.8,3.6c0.2,0.9,0.6,1.5,1.1,1.7 c0.4,0.2,1,0.1,1.6-0.2c1.4-0.8,1.9-2.2,1.5-3.9L480.9,694.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M487.3,690.8l-0.5,0.3l0.5,2.4c0.2,0.9,0.4,1.6,0.6,2.4l0,0.1l-0.1,0.2l-0.1-0.1 c-0.4-0.5-0.9-0.9-1.4-1.4l-2.4-2l-0.6,0.3l1.3,5.7l0.5-0.3l-0.5-2.4c-0.2-1-0.4-1.7-0.6-2.4l0-0.1l0.2-0.2l0.1,0.1 c0.4,0.4,0.8,0.9,1.5,1.4l2.4,2l0.6-0.3L487.3,690.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M487.9,696l0.1-0.2l0-0.1c-0.2-0.8-0.4-1.5-0.6-2.4l-0.5-2.4l0.5-0.3l1.3,5.7l-0.6,0.3l-2.4-2 c-0.6-0.5-1.1-1-1.5-1.4l-0.1-0.1l-0.2,0.2l0,0.1c0.2,0.7,0.4,1.4,0.6,2.4l0.5,2.4l-0.5,0.3l-1.3-5.7l0.6-0.3l2.4,2 C486.9,695,487.4,695.5,487.9,696L487.9,696 M487.4,690.4l-0.9,0.5l0.6,2.6c0.2,0.7,0.3,1.3,0.5,1.9 c-0.3-0.4-0.7-0.7-1.1-1l-2.4-2l0,0l-0.9,0.5l1.4,6.1l0,0.1l0.9-0.5l-0.6-2.6c-0.2-0.8-0.3-1.4-0.5-2 c0.3,0.4,0.7,0.7,1.2,1.1l2.4,2.1l0,0l0.9-0.5l-1.4-6L487.4,690.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "490.5,689 489.9,689.3 491.2,695 491.7,694.7 490.5,689  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M491.2,695l-1.3-5.7l0.5-0.3l1.3,5.7L491.2,695 M490.6,688.7l-0.9,0.5l1.4,6.1l0,0.1l0.9-0.5 l-1.4-6.1L490.6,688.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M496.8,685.5l-0.5,0.3l-0.3,3.4c-0.1,1-0.1,1.8-0.1,2.5l0,0.1l-0.2,0.1l-0.1-0.1 c-0.3-0.6-0.6-1.2-1.1-1.9l-1.5-2.4l-0.6,0.3l3,4.8l0.6-0.4L496.8,685.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M495.7,691.8l0.2-0.1l0-0.1c0-0.7,0-1.6,0.1-2.5l0.3-3.4l0.5-0.3l-0.6,6.8l-0.6,0.4l-3-4.8l0.6-0.3 l1.5,2.4C495,690.6,495.4,691.2,495.7,691.8L495.7,691.8 M497,685.1l-1,0.5l-0.3,3.5c-0.1,0.8-0.1,1.5-0.1,2.1 c-0.3-0.5-0.6-1-0.9-1.6l-1.5-2.5l-1,0.5l3.2,5.1l0.9-0.5L497,685.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "501.6,682.8 498.9,684.3 500.2,690 503,688.4 502.9,688 500.6,689.3 500,687 502.1,685.8  502,685.4 499.9,686.6 499.5,684.5 501.7,683.2 501.6,682.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M500.2,690l-1.3-5.7l2.7-1.5l0.1,0.4l-2.2,1.2l0.5,2.1l2.1-1.2l0.1,0.4L500,687l0.5,2.3l2.4-1.3 l0.1,0.4L500.2,690 M501.8,682.5l-3.1,1.7l1.4,6l0,0.1l3.3-1.8l-0.2-0.9l-2.4,1.3l-0.4-1.9l2.1-1.2l-0.2-0.9l-2.1,1.2 l-0.4-1.7l2.2-1.2L501.8,682.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M505.2,683.9l-0.5-2.4l0.1-0.1c0.1-0.1,0.3-0.3,0.7-0.5c0.5-0.3,0.9-0.3,1.2-0.2 c0.2,0.1,0.4,0.3,0.5,0.7c0.1,0.4,0,0.7-0.2,1.1c-0.2,0.4-0.5,0.7-0.9,0.9L505.2,683.9 M507,680.3 C507,680.3,507,680.3,507,680.3c-0.5-0.2-1-0.1-1.7,0.3c-0.5,0.3-0.9,0.6-1.2,0.8l1.3,5.7l0.5-0.3l-0.6-2.6l0.8-0.4 c0.4-0.2,0.7-0.2,0.9-0.1c0.2,0.1,0.4,0.3,0.6,0.7c0.2,0.5,0.5,1,0.6,1.2l0.5-0.3c-0.2-0.2-0.4-0.7-0.7-1.3 c-0.2-0.3-0.4-0.6-0.6-0.7c-0.1-0.1-0.3-0.1-0.4-0.1l-0.1,0l0-0.2l0.1-0.1c0.6-0.6,0.8-1.3,0.6-1.9 C507.5,680.7,507.3,680.5,507,680.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M505.4,683.6l-0.4-2c0.1-0.1,0.3-0.2,0.6-0.4c0.3-0.2,0.7-0.3,1-0.2c0.2,0.1,0.3,0.2,0.4,0.5 c0.1,0.3,0,0.6-0.1,0.9c-0.2,0.3-0.4,0.6-0.8,0.8L505.4,683.6 M506.6,680.8c-0.3-0.1-0.7-0.1-1.2,0.2 c-0.4,0.2-0.6,0.4-0.7,0.5l-0.1,0.1l0.5,2.4l0.8-0.5c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.2-0.7,0.2-1.1 C507,681.1,506.8,680.9,506.6,680.8 M505.4,687.1l-1.3-5.7c0.3-0.2,0.8-0.5,1.2-0.8c0.7-0.4,1.2-0.5,1.6-0.4 c0,0,0.1,0,0.1,0c0.3,0.1,0.5,0.4,0.5,0.8c0.1,0.7-0.1,1.4-0.6,1.9l-0.1,0.1l0,0.2l0.1,0c0.1,0,0.3,0,0.4,0.1 c0.2,0.1,0.4,0.3,0.6,0.7c0.3,0.6,0.5,1.1,0.7,1.3l-0.5,0.3c-0.1-0.2-0.4-0.7-0.6-1.2c-0.2-0.4-0.4-0.6-0.6-0.7 c-0.2-0.1-0.5-0.1-0.9,0.1l-0.8,0.4l0.6,2.6L505.4,687.1 M507.1,680.1C507.1,680.1,507.1,680.1,507.1,680.1 c-0.5-0.2-1.1-0.1-1.9,0.4c-0.5,0.3-1,0.6-1.3,0.9l-0.1,0.1l1.3,6l0,0.1l0.9-0.5l-0.6-2.6l0.6-0.3c0.3-0.2,0.5-0.2,0.7-0.1 c0.2,0.1,0.3,0.3,0.5,0.6c0.4,0.8,0.6,1.1,0.7,1.2l0,0l0.9-0.5l-0.1-0.1c-0.2-0.2-0.4-0.7-0.8-1.4 c-0.2-0.4-0.4-0.6-0.6-0.7c-0.1,0-0.2-0.1-0.3-0.1c0.5-0.6,0.7-1.3,0.6-2C507.7,680.6,507.4,680.2,507.1,680.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M512.3,677c-0.2,0-0.6,0.1-1.1,0.4c-1,0.5-1.5,1.5-1.3,2.4c0.1,0.4,0.3,0.6,0.6,0.7 c0.3,0.1,0.7,0.2,1.2,0.1c0.4-0.1,0.7,0,1,0.1c0.2,0.1,0.4,0.3,0.4,0.6c0.1,0.3,0,0.7-0.2,1c-0.2,0.3-0.5,0.6-0.8,0.8 c-0.4,0.2-0.9,0.4-1.3,0.3l0,0.5c0.3,0,0.9-0.1,1.3-0.4c0.6-0.3,1-0.7,1.3-1.2c0.2-0.4,0.3-0.9,0.2-1.4 c-0.1-0.4-0.3-0.7-0.6-0.8c-0.3-0.1-0.6-0.2-1.1-0.1c-0.4,0.1-0.8,0.1-1-0.1c-0.2-0.1-0.3-0.3-0.4-0.6 c-0.1-0.3,0-0.6,0.1-0.8c0.2-0.3,0.4-0.6,0.8-0.8c0.4-0.2,0.8-0.3,1-0.3L512.3,677"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M510.4,680.5c-0.3-0.1-0.5-0.4-0.6-0.7c-0.2-0.9,0.3-1.9,1.3-2.4c0.5-0.3,0.9-0.4,1.1-0.4l0,0.5 c-0.3,0-0.6,0.1-1,0.3c-0.4,0.2-0.6,0.5-0.8,0.8c-0.1,0.3-0.2,0.6-0.1,0.8c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.6,0.1,1,0.1 c0.5-0.1,0.9,0,1.1,0.1c0.3,0.1,0.5,0.4,0.6,0.8c0.1,0.4,0,0.9-0.2,1.4c-0.2,0.5-0.7,0.9-1.3,1.2c-0.5,0.3-1,0.4-1.3,0.4 l0-0.5c0.4,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.5,0.8-0.8c0.2-0.3,0.2-0.7,0.2-1c-0.1-0.3-0.2-0.5-0.4-0.6 c-0.2-0.1-0.5-0.1-1-0.1C511,680.7,510.6,680.7,510.4,680.5 M512.5,676.8L512.5,676.8c-0.3,0-0.7,0-1.4,0.4 c-1.1,0.6-1.7,1.7-1.5,2.8c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.1,0.7,0.2,1.3,0.1c0.4-0.1,0.7,0,0.9,0c0.2,0.1,0.3,0.2,0.3,0.5 c0.1,0.3,0,0.5-0.1,0.8c-0.1,0.3-0.4,0.5-0.7,0.7c-0.4,0.2-0.9,0.3-1.3,0.3l-0.1,0l0,1l0.1,0c0.4,0.1,1-0.1,1.5-0.4 c0.6-0.4,1.1-0.8,1.4-1.4c0.2-0.5,0.3-1.1,0.2-1.6c-0.1-0.5-0.3-0.8-0.7-0.9c-0.3-0.1-0.7-0.2-1.2-0.1 c-0.5,0.1-0.8,0-0.9,0c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0-0.4,0.1-0.6c0.1-0.3,0.3-0.5,0.7-0.7c0.4-0.3,0.8-0.3,1-0.3l0.1,0 L512.5,676.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "515.4,675.1 514.9,675.4 516.2,681.1 516.7,680.8 515.4,675.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M516.2,681.1l-1.3-5.7l0.5-0.3l1.3,5.7L516.2,681.1 M515.5,674.8l-0.9,0.5l1.4,6l0,0.1l0.9-0.5 l-1.4-6.1L515.5,674.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "521.3,671.8 517.4,674 517.5,674.4 519.2,673.5 520.4,678.8 520.9,678.5 519.7,673.2  521.4,672.3 521.3,671.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M517.5,674.4l-0.1-0.4l3.8-2.1l0.1,0.4l-1.7,0.9l1.2,5.3l-0.5,0.3l-1.2-5.3L517.5,674.4  M521.4,671.5l-4.1,2.3l-0.1,0.1l0.2,0.9l1.7-0.9l1.2,5.3l0.9-0.5l-1.2-5.3l1.7-0.9L521.4,671.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M526.8,668.8l-0.6,0.3l-0.4,2.2c-0.1,0.5-0.2,0.9-0.2,1.3l0,0.1l-0.1,0.1l-0.1,0 c-0.3-0.3-0.5-0.6-0.8-0.9l-1.1-1.2l-0.6,0.3l2.4,2.4l0.5,2.4l0.5-0.3l-0.6-2.4l0,0L526.8,668.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M525.4,672.8l0.1-0.1l0-0.1c0.1-0.4,0.1-0.8,0.2-1.3l0.4-2.2l0.6-0.3l-1,4.2l0,0l0.6,2.4l-0.5,0.3 l-0.5-2.4l-2.4-2.4l0.6-0.3l1.1,1.2C524.8,672.1,525.1,672.4,525.4,672.8L525.4,672.8 M527.1,668.4l-1,0.6l-0.4,2.1l0,0.2 c-0.1,0.4-0.1,0.7-0.2,1.1c-0.2-0.3-0.5-0.5-0.7-0.8l-1.2-1.3l-1,0.6l2.6,2.6l0.6,2.6l0.9-0.5L526,673L527.1,668.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "532.4,665.7 531.9,665.9 533.2,671.7 536,670.1 535.9,669.7 533.6,671 532.4,665.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M533.2,671.7l-1.3-5.7l0.5-0.3l1.2,5.3l2.3-1.3l0.1,0.4L533.2,671.7 M532.5,665.3l-0.9,0.5l1.4,6 l0,0.1l3.2-1.8l-0.2-0.9l-2.3,1.3l-1.2-5.2L532.5,665.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st170",
    points: "537.4,662.8 536.9,663.1 538.2,668.8 538.7,668.6 537.4,662.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M538.2,668.8l-1.3-5.7l0.5-0.3l1.3,5.7L538.2,668.8 M537.6,662.5l-0.9,0.5l1.4,6l0,0.1l0.9-0.5 l-1.4-6L537.6,662.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M541.8,666.4l-0.6-2.5l0.7-0.4c0.5-0.3,1-0.4,1.3-0.2l0,0c0.2,0.1,0.4,0.3,0.5,0.6 c0.1,0.4,0,0.9-0.3,1.3c-0.2,0.3-0.5,0.6-1,0.8C542.2,666.2,542,666.3,541.8,666.4L541.8,666.4 M541.2,663.6l-0.5-2.1 l0.1-0.1c0.2-0.1,0.4-0.3,0.6-0.4c0.5-0.3,0.9-0.3,1.1-0.2c0.2,0.1,0.3,0.3,0.4,0.6c0.1,0.7-0.3,1.4-1,1.8L541.2,663.6  M542.9,660.3c0,0-0.1,0-0.2-0.1c-0.4-0.1-0.8,0-1.5,0.4c-0.4,0.2-0.9,0.5-1.2,0.8l1.3,5.7c0.2-0.1,0.5-0.2,1-0.5 c0.9-0.5,1.4-1,1.7-1.5c0.2-0.5,0.3-0.9,0.2-1.3c-0.1-0.4-0.3-0.6-0.5-0.8c-0.3-0.1-0.6-0.1-0.8,0l-0.1,0l0-0.2l0.1-0.1 c0.5-0.5,0.7-1.1,0.6-1.7C543.3,660.7,543.2,660.4,542.9,660.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M542,666.1l-0.5-2.1l0.5-0.3c0.5-0.3,0.9-0.3,1.2-0.2l0,0c0.2,0.1,0.3,0.3,0.4,0.5 c0.1,0.4,0,0.7-0.2,1c-0.2,0.3-0.5,0.5-0.9,0.7C542.2,666,542.1,666.1,542,666.1 M543.3,663.4L543.3,663.4 c-0.4-0.2-0.8-0.1-1.3,0.2l-0.7,0.4l0.6,2.5l0.1,0c0.1,0,0.3-0.1,0.6-0.3c0.4-0.2,0.8-0.5,1-0.8c0.3-0.4,0.3-0.8,0.3-1.3 C543.6,663.7,543.5,663.5,543.3,663.4 M541.3,663.3l-0.4-1.7c0.1-0.1,0.3-0.2,0.5-0.3c0.4-0.2,0.8-0.3,1-0.2 c0.2,0.1,0.3,0.2,0.3,0.5c0.1,0.5-0.2,1.1-0.9,1.5L541.3,663.3 M542.5,660.8c-0.2-0.1-0.6-0.1-1.1,0.2 c-0.3,0.2-0.5,0.3-0.6,0.4l-0.1,0.1l0.5,2.1l0.7-0.4c0.8-0.4,1.2-1.2,1-1.8C542.9,661.1,542.8,660.9,542.5,660.8  M541.4,667.1l-1.3-5.7c0.3-0.2,0.7-0.5,1.2-0.8c0.7-0.4,1.1-0.5,1.5-0.4c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.4,0.3,0.5,0.7 c0.1,0.5-0.1,1.2-0.6,1.7l-0.1,0.1l0,0.2l0.1,0c0.3-0.1,0.6-0.1,0.8,0c0.2,0.1,0.5,0.4,0.5,0.8c0.1,0.4,0,0.9-0.2,1.3 c-0.3,0.5-0.8,1.1-1.7,1.5C541.9,666.8,541.6,667,541.4,667.1 M543.1,660.1c-0.1,0-0.1,0-0.2-0.1c-0.4-0.1-0.9,0-1.7,0.4 c-0.5,0.3-1,0.6-1.3,0.9l-0.1,0.1l1.4,6l0.1,0c0.2-0.1,0.6-0.2,1.1-0.5c0.9-0.5,1.5-1.1,1.8-1.7c0.2-0.5,0.3-1,0.2-1.5 c-0.1-0.5-0.3-0.7-0.6-0.9c-0.2-0.1-0.5-0.1-0.7-0.1c0.4-0.5,0.6-1.2,0.5-1.7C543.5,660.5,543.3,660.2,543.1,660.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M546.8,660.7l-0.5-2.4l0.1-0.1c0.1-0.1,0.3-0.3,0.7-0.5c0.5-0.3,0.9-0.3,1.2-0.2 c0.2,0.1,0.4,0.3,0.5,0.7c0.1,0.4,0,0.7-0.2,1.1c-0.2,0.4-0.5,0.7-0.9,0.9L546.8,660.7 M548.7,657.2 C548.6,657.1,548.6,657.1,548.7,657.2c-0.5-0.2-1-0.1-1.7,0.3c-0.5,0.3-0.9,0.5-1.2,0.8l1.3,5.7l0.5-0.3l-0.6-2.6l0.8-0.4 c0.4-0.2,0.6-0.2,0.9-0.1c0.2,0.1,0.4,0.3,0.6,0.7c0.2,0.5,0.5,1,0.6,1.2l0.5-0.3c-0.2-0.2-0.4-0.7-0.7-1.3 c-0.2-0.3-0.4-0.6-0.6-0.7c-0.1-0.1-0.3-0.1-0.4-0.1l-0.1,0l0-0.1l0.1-0.1c0.6-0.6,0.8-1.3,0.6-1.9 C549.1,657.6,548.9,657.3,548.7,657.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M547,660.4l-0.4-2c0.1-0.1,0.3-0.2,0.6-0.4c0.3-0.2,0.7-0.3,1-0.2c0.2,0.1,0.3,0.2,0.4,0.5 c0.1,0.3,0,0.6-0.1,0.9c-0.2,0.3-0.4,0.6-0.8,0.8L547,660.4 M548.3,657.6c-0.3-0.1-0.7-0.1-1.2,0.2 c-0.4,0.2-0.6,0.4-0.7,0.5l-0.1,0.1l0.5,2.4l0.8-0.5c0.4-0.2,0.7-0.5,0.9-0.9c0.2-0.4,0.2-0.7,0.2-1.1 C548.6,658,548.5,657.8,548.3,657.6 M547,664l-1.3-5.7c0.3-0.3,0.8-0.6,1.2-0.8c0.7-0.4,1.2-0.5,1.6-0.4c0,0,0.1,0,0.1,0 c0.3,0.1,0.5,0.4,0.5,0.8c0.1,0.7-0.1,1.4-0.6,1.9l-0.1,0.1l0,0.1l0.1,0c0.2,0,0.3,0,0.4,0.1c0.2,0.1,0.4,0.3,0.6,0.7 c0.3,0.6,0.5,1.1,0.7,1.3l-0.5,0.3c-0.1-0.2-0.4-0.7-0.6-1.2c-0.2-0.4-0.4-0.6-0.6-0.7c-0.2-0.1-0.5-0.1-0.9,0.1l-0.8,0.4 l0.6,2.6L547,664 M548.8,656.9c0,0-0.1,0-0.1,0c-0.4-0.2-1,0-1.8,0.4c-0.5,0.3-1,0.6-1.3,0.9l-0.1,0.1l1.3,6l0,0.1l0.9-0.5 l-0.6-2.6l0.6-0.3c0.3-0.2,0.5-0.2,0.7-0.1c0.2,0.1,0.3,0.3,0.5,0.6c0.4,0.8,0.6,1.1,0.7,1.2l0,0l0.9-0.5l-0.1-0.1 c-0.2-0.2-0.4-0.7-0.8-1.4c-0.2-0.4-0.4-0.6-0.6-0.7c-0.1,0-0.2-0.1-0.3-0.1c0.5-0.6,0.7-1.3,0.6-2 C549.3,657.4,549.1,657.1,548.8,656.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M552.9,658.2l0.2-2.2c0-0.4,0-0.8,0-1.2l0-0.1l0.1-0.1l0.1,0.1l0,0.1c0.1,0.3,0.3,0.6,0.5,0.8l1,1.5 L552.9,658.2 M553.4,653.9l-0.7,0.4l-0.5,6.7l0.5-0.3l0.1-2.2l2.1-1.2l1,1.5l0.5-0.3L553.4,653.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M553.1,657.8l0.1-1.9c0-0.3,0-0.5,0-0.8c0.1,0.2,0.2,0.4,0.4,0.6l0.8,1.3L553.1,657.8 M553.2,654.6 l-0.1,0.1l0,0.1c0,0.5,0,0.9,0,1.2l-0.2,2.2l1.9-1.1l-1-1.5c-0.2-0.3-0.3-0.6-0.5-0.8L553.2,654.6L553.2,654.6  M552.2,661.1l0.5-6.7l0.7-0.4l3.1,4.7l-0.5,0.3l-1-1.5l-2.1,1.2l-0.1,2.2L552.2,661.1 M553.5,653.7l-1,0.5l-0.5,7.2 l0.9-0.5l0.1-2.2l1.8-1l1,1.5l1-0.5L553.5,653.7L553.5,653.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M558.6,654.2l-0.5-2.4l0.1-0.1c0.1-0.1,0.4-0.3,0.7-0.5c0.5-0.3,0.9-0.3,1.2-0.2 c0.2,0.1,0.4,0.3,0.5,0.7c0.2,0.7-0.3,1.5-1,2L558.6,654.2 M560.4,650.6C560.4,650.6,560.4,650.6,560.4,650.6 c-0.5-0.2-1-0.1-1.7,0.3c-0.5,0.3-0.9,0.5-1.2,0.8l1.3,5.7l0.5-0.3l-0.6-2.6l0.8-0.4c0.4-0.2,0.7-0.2,0.9-0.1 c0.2,0.1,0.4,0.3,0.6,0.7c0.2,0.5,0.5,1,0.6,1.2l0.5-0.3c-0.2-0.2-0.4-0.7-0.7-1.3c-0.2-0.3-0.4-0.6-0.6-0.7 c-0.1-0.1-0.3-0.1-0.4-0.1l-0.1,0l0-0.1l0.1-0.1c0.6-0.6,0.8-1.3,0.6-1.9C560.9,651,560.7,650.7,560.4,650.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M558.8,653.9l-0.4-2c0.1-0.1,0.3-0.2,0.6-0.4c0.3-0.2,0.7-0.3,1-0.2c0.2,0.1,0.3,0.2,0.4,0.5 c0.1,0.6-0.2,1.3-0.9,1.6L558.8,653.9 M560,651.1c-0.3-0.1-0.7-0.1-1.2,0.2c-0.3,0.2-0.6,0.3-0.7,0.5l-0.1,0.1l0.5,2.4 l0.8-0.5c0.8-0.4,1.2-1.2,1-2C560.4,651.4,560.2,651.2,560,651.1 M558.8,657.4l-1.3-5.7c0.3-0.3,0.8-0.6,1.2-0.8 c0.7-0.4,1.2-0.5,1.6-0.4c0,0,0.1,0,0.1,0c0.3,0.1,0.4,0.4,0.5,0.8c0.1,0.7-0.1,1.4-0.6,1.9l-0.1,0.1l0,0.1l0.1,0 c0.2,0,0.3,0,0.4,0.1c0.2,0.1,0.4,0.3,0.6,0.7c0.3,0.6,0.5,1.1,0.7,1.3l-0.5,0.3c-0.1-0.2-0.4-0.7-0.6-1.2 c-0.2-0.4-0.4-0.6-0.6-0.7c-0.2-0.1-0.5-0.1-0.9,0.1l-0.8,0.4l0.6,2.6L558.8,657.4 M560.5,650.4 C560.5,650.4,560.4,650.3,560.5,650.4c-0.5-0.2-1.1-0.1-1.8,0.4c-0.5,0.3-1,0.6-1.3,0.9l-0.1,0.1l1.3,6l0,0.1l0.9-0.5 l-0.6-2.6l0.6-0.3c0.3-0.2,0.5-0.2,0.7-0.1c0.2,0.1,0.3,0.3,0.5,0.6c0.4,0.8,0.6,1.1,0.7,1.2l0,0l0.9-0.5l-0.1-0.1 c-0.2-0.2-0.4-0.7-0.8-1.4c-0.2-0.4-0.4-0.6-0.6-0.7c-0.1,0-0.2-0.1-0.3-0.1c0.5-0.6,0.7-1.3,0.6-2 C561,650.8,560.8,650.5,560.5,650.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M566.5,646.6L566,647l-0.4,2.2c-0.1,0.5-0.2,0.9-0.2,1.3l0,0.1l-0.1,0.1l-0.1,0 c-0.2-0.3-0.5-0.6-0.8-0.9l-1.1-1.2l-0.6,0.3l2.4,2.4l0.5,2.4l0.5-0.3l-0.6-2.4l0,0L566.5,646.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M565.2,650.6l0.1-0.1l0-0.1c0.1-0.4,0.1-0.8,0.2-1.3l0.4-2.2l0.6-0.3l-1,4.2l0,0l0.6,2.4l-0.5,0.3 l-0.5-2.4l-2.4-2.4l0.6-0.3l1.1,1.2C564.6,650,564.9,650.3,565.2,650.6L565.2,650.6 M566.8,646.2l-1,0.6l-0.4,2.1l-0.1,0.2 c-0.1,0.4-0.1,0.7-0.2,1c-0.2-0.2-0.4-0.5-0.7-0.8l-1.2-1.2l-1,0.6l2.6,2.6l0.6,2.6l0.9-0.5l-0.6-2.6L566.8,646.2"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "trees"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    className: "st8",
    d: "M275.6,869l0-2.2c0,1,0.5,1.9,1.5,2.7l0,2.2C276.1,870.9,275.6,869.9,275.6,869z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M277.1,869.5l0,2.2c-1-0.8-1.5-1.7-1.5-2.7l0-2.2C275.6,867.8,276.1,868.8,277.1,869.5"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    className: "st8",
    d: "M309,866.6l0,2.2c0,1.1-0.6,2.1-1.8,2.9l0-2.2C308.4,868.7,309,867.7,309,866.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M309,866.6l0,2.2c0,0,0,0,0,0.1L309,866.6C309,866.7,309,866.6,309,866.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M309,866.7l0,2.2c0,0.2,0,0.4-0.1,0.5l0-2.2C309,867,309,866.9,309,866.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M308.9,867.2l0,2.2c0,0.2-0.1,0.4-0.2,0.6l0-2.2C308.8,867.6,308.9,867.4,308.9,867.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M308.8,867.8l0,2.2c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.2C308.5,868.3,308.6,868,308.8,867.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M308.3,868.5l0,2.2c-0.3,0.4-0.7,0.7-1.1,1l0-2.2C307.7,869.2,308.1,868.8,308.3,868.5"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "287.3,877.1 287.3,879.2 277.1,871.7 277.1,869.5  "
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "307.2,869.5 307.2,871.6 295.4,879.4 295.4,877.2  "
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M292.8,855.1c1.6-0.1,3.2,0.4,4.4,1.2l10.2,7.5c2.1,1.6,2,4.1-0.3,5.6l-11.9,7.7c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-10.2-7.6c-2.1-1.6-2-4.1,0.2-5.6l11.9-7.7C290.3,855.5,291.5,855.2,292.8,855.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    className: "st8",
    d: "M295.4,877.2l0,2.2c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.2 c1.2,0.9,2.8,1.3,4.4,1.2C293.1,878.2,294.3,877.9,295.4,877.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "st174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M295.4,877.2l0,2.2c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.2C294.6,877.6,295,877.5,295.4,877.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M294.2,877.8l0,2.2c-0.3,0.1-0.6,0.2-1,0.3l0-2.2C293.6,878,293.9,877.9,294.2,877.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M293.3,878.1l0,2.2c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.2C292.7,878.2,293,878.2,293.3,878.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M292.4,878.2l0,2.2c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.2c0,0,0,0,0.1,0 C292,878.3,292.2,878.3,292.4,878.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M291.7,878.3l0,2.2c-0.3,0-0.5,0-0.8,0l0-2.2C291.2,878.3,291.4,878.3,291.7,878.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M290.9,878.3l0,2.2c-0.3,0-0.5,0-0.8-0.1l0-2.2C290.4,878.2,290.7,878.3,290.9,878.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M290.1,878.2l0,2.2c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.2C289.5,878.1,289.8,878.1,290.1,878.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M289.2,878l0,2.2c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.2C287.9,877.5,288.5,877.8,289.2,878"
  }))))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M292.5,870.1h-1.3c-1.6,0-3-1.3-3-3v-21.4c0-0.8,0.6-1.4,1.4-1.4h4.5c0.8,0,1.4,0.6,1.4,1.4v21.4 C295.5,868.8,294.2,870.1,292.5,870.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M287.5,854.2c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.6-6.1-6.5-10.9-9.8-14.2c-1.3-1.4-3.5-1.3-4.8,0.1c-3,3.4-6.4,8-9,14.1c-2.8,6.7-7.6,18.2-1.7,27.1 C280.8,850.6,284.3,852.8,287.5,854.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M287.5,839c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.7,9.1-7.4c5.9-9.2,1.1-21.1-1.7-28.1c-1-2.5-2.3-4.8-3.6-6.9 c-4-6.2-13-6.1-16.7,0.3c-1.2,2-2.3,4.2-3.3,6.6c-2.8,7-7.6,18.8-1.7,28.1C280.8,835.3,284.3,837.6,287.5,839z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M287.5,836.3c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.1-4.9-5-8.9-7.7-12c-2.3-2.7-6.5-2.6-8.7,0.1c-2.5,3.1-5,7-7.1,11.9c-2.8,6.7-7.6,18.2-1.7,27.1 C280.8,832.8,284.3,835,287.5,836.3z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st167"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "288.3,857.1 295.5,857.3 295.5,857.8 288.3,857.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "288.3,858.5 295.5,857.6 295.5,857.8 288.3,859.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "treee_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_59_",
    className: "st8",
    d: "M339.9,914.1l0-2.2c0,1,0.5,1.9,1.5,2.7l0,2.2C340.4,916,339.9,915,339.9,914.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "st176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M341.4,914.6l0,2.2c-1-0.8-1.5-1.7-1.5-2.7l0-2.2C339.9,912.9,340.4,913.9,341.4,914.6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    className: "st8",
    d: "M373.3,911.7l0,2.2c0,1.1-0.6,2.1-1.8,2.9l0-2.2C372.7,913.8,373.3,912.8,373.3,911.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M373.3,911.7l0,2.2c0,0,0,0,0,0.1L373.3,911.7C373.3,911.7,373.3,911.7,373.3,911.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M373.3,911.8l0,2.2c0,0.2,0,0.4-0.1,0.5l0-2.2C373.3,912.1,373.3,911.9,373.3,911.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M373.2,912.3l0,2.2c0,0.2-0.1,0.4-0.2,0.6l0-2.2C373.1,912.7,373.2,912.5,373.2,912.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M373.1,912.9l0,2.2c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.2C372.8,913.3,373,913.1,373.1,912.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M372.6,913.6l0,2.2c-0.3,0.4-0.7,0.7-1.1,1l0-2.2C372,914.3,372.4,913.9,372.6,913.6"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "351.6,922.2 351.6,924.3 341.4,916.8 341.4,914.6  "
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "371.5,914.6 371.5,916.7 359.7,924.5 359.7,922.3  "
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M357.1,900.2c1.6-0.1,3.2,0.4,4.4,1.2l10.2,7.5c2.1,1.6,2,4.1-0.3,5.6l-11.9,7.7c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-10.2-7.5c-2.1-1.6-2-4.1,0.3-5.6l11.9-7.7C354.6,900.6,355.8,900.3,357.1,900.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_63_",
    className: "st8",
    d: "M359.7,922.3l0,2.2c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.2 c1.2,0.9,2.8,1.3,4.4,1.2C357.4,923.3,358.6,923,359.7,922.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "st178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M359.7,922.3l0,2.2c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.2C358.9,922.7,359.3,922.5,359.7,922.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M358.6,922.9l0,2.2c-0.3,0.1-0.6,0.2-1,0.3l0-2.2C357.9,923.1,358.2,923,358.6,922.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M357.6,923.2l0,2.2c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.2C357,923.3,357.3,923.3,357.6,923.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M356.8,923.3l0,2.2c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.2c0,0,0,0,0.1,0 C356.3,923.4,356.5,923.4,356.8,923.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M356,923.4l0,2.2c-0.3,0-0.5,0-0.8,0l0-2.2C355.5,923.4,355.7,923.4,356,923.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M355.2,923.4l0,2.2c-0.3,0-0.5,0-0.8-0.1l0-2.2C354.7,923.3,355,923.4,355.2,923.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M354.4,923.3l0,2.2c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.2C353.8,923.2,354.1,923.2,354.4,923.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M353.5,923.1l0,2.2c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.2C352.2,922.6,352.8,922.9,353.5,923.1"
  }))))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M356.8,915.2h-1.3c-1.6,0-3-1.3-3-3v-21.4c0-0.8,0.6-1.4,1.4-1.4h4.5c0.8,0,1.4,0.6,1.4,1.4v21.4 C359.8,913.9,358.5,915.2,356.8,915.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M351.8,899.3c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.6-6.1-6.5-10.9-9.8-14.2c-1.3-1.4-3.5-1.3-4.8,0.1c-3,3.4-6.4,8-9,14.1c-2.8,6.7-7.6,18.2-1.7,27.1 C345.1,895.7,348.6,897.9,351.8,899.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M351.8,884.1c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.7,9.1-7.4c5.9-9.2,1.1-21.1-1.7-28.1 c-1-2.5-2.3-4.8-3.6-6.9c-4-6.2-13-6.1-16.7,0.3c-1.2,2-2.3,4.2-3.3,6.6c-2.8,7-7.6,18.8-1.7,28.1 C345.1,880.4,348.6,882.7,351.8,884.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M351.8,881.4c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.1-4.9-5-8.9-7.7-12c-2.3-2.7-6.5-2.6-8.7,0.1c-2.5,3.1-5,7-7.1,11.9c-2.8,6.7-7.6,18.2-1.7,27.1 C345.1,877.9,348.6,880.1,351.8,881.4z"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "st167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st168"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st179",
    x1: 352.5,
    y1: 904.2,
    x2: 334.5,
    y2: 899.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st179",
    x1: 352,
    y1: 904.1,
    x2: 337.8,
    y2: 897
  }), /*#__PURE__*/React.createElement("line", {
    className: "st179",
    x1: 352.5,
    y1: 904.2,
    x2: 343.2,
    y2: 892.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st179",
    x1: 352.5,
    y1: 904.2,
    x2: 340.7,
    y2: 894.6
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "360,903.2 352,903.7 352,904.1 360,904  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st175",
    points: "360,906.4 352.5,904.2 352.5,904.6 360,907.7  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "bushes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_65_",
    className: "st8",
    d: "M796.7,702l0-2.4c0,1,0.5,1.9,1.5,2.7l0,2.4C797.2,703.9,796.7,703,796.7,702z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_65_",
    style: {
      overflow: "visible"
    }
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M798.3,702.3l0,2.4c-1-0.8-1.5-1.7-1.5-2.7l0-2.4C796.7,700.6,797.2,701.6,798.3,702.3"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_67_",
    className: "st8",
    d: "M834.1,699.4l0,2.4c0,1.1-0.6,2.1-1.8,2.9l0-2.4C833.5,701.5,834.1,700.5,834.1,699.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M834.1,699.4l0,2.4c0,0,0,0,0,0.1L834.1,699.4C834.1,699.5,834.1,699.4,834.1,699.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M834.1,699.5l0,2.4c0,0.2,0,0.4-0.1,0.5l0-2.4C834.1,699.8,834.1,699.7,834.1,699.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M834,700l0,2.4c0,0.2-0.1,0.4-0.2,0.6l0-2.4C833.9,700.4,834,700.2,834,700"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M833.9,700.6l0,2.4c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.4C833.6,701.1,833.7,700.8,833.9,700.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M833.4,701.3l0,2.4c-0.3,0.4-0.7,0.7-1.1,1l0-2.4C832.8,702,833.2,701.7,833.4,701.3"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "810.4,711.2 810.4,713.6 798.3,704.7 798.3,702.3  "
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "832.3,702.3 832.3,704.7 818.4,713.8 818.4,711.4  "
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M816.1,686.6c1.6-0.1,3.2,0.4,4.4,1.2l12.1,8.9c2.1,1.6,2,4.1-0.3,5.6l-14,9.1c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-12.1-8.9c-2.1-1.6-2-4.1,0.3-5.6l14-9.1C813.5,687,814.8,686.6,816.1,686.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_69_",
    className: "st8",
    d: "M818.4,711.4l0,2.4c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.4 c1.2,0.9,2.8,1.3,4.4,1.2C816.1,712.4,817.3,712.1,818.4,711.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "st182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M818.4,711.4l0,2.4c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.4C817.6,711.8,818,711.6,818.4,711.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M817.3,712l0,2.4c-0.3,0.1-0.6,0.2-1,0.3l0-2.4C816.6,712.2,816.9,712.1,817.3,712"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M816.3,712.3l0,2.4c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.4C815.7,712.4,816,712.3,816.3,712.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M815.5,712.4l0,2.4c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.4c0,0,0,0,0.1,0 C815,712.5,815.2,712.4,815.5,712.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M814.7,712.5l0,2.4c-0.3,0-0.5,0-0.8,0l0-2.4C814.2,712.5,814.4,712.5,814.7,712.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M813.9,712.5l0,2.4c-0.3,0-0.5,0-0.8-0.1l0-2.4C813.4,712.4,813.7,712.4,813.9,712.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M813.1,712.4l0,2.4c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.4C812.5,712.2,812.8,712.3,813.1,712.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M812.2,712.2l0,2.4c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.4C810.9,711.6,811.5,712,812.2,712.2"
  }))))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M811.2,706.5c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.7,9.1-7.4c5.9-9.2,1.1-21.1-1.7-28.1 c-1-2.5-2.3-4.8-3.6-6.9c-4-6.2-13-6.1-16.7,0.3c-1.2,2-2.3,4.2-3.3,6.6c-2.8,7-7.6,18.8-1.7,28.1 C804.6,702.8,808,705.1,811.2,706.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M811.2,703.8c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.1-4.9-5-8.9-7.7-12c-2.3-2.7-6.5-2.6-8.7,0.1c-2.5,3.1-5,7-7.1,11.9c-2.8,6.7-7.6,18.2-1.7,27.1 C804.6,700.3,808,702.5,811.2,703.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_71_",
    className: "st8",
    d: "M934,808.9l0-2.4c0,1,0.5,1.9,1.5,2.7l0,2.4C934.5,810.8,934,809.8,934,808.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_71_",
    style: {
      overflow: "visible"
    }
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "st183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M935.5,809.2l0,2.4c-1-0.8-1.5-1.7-1.5-2.7l0-2.4C934,807.4,934.5,808.4,935.5,809.2"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_73_",
    className: "st8",
    d: "M971.4,806.3l0,2.4c0,1.1-0.6,2.1-1.8,2.9l0-2.4C970.8,808.4,971.4,807.3,971.4,806.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_73_",
    style: {
      overflow: "visible"
    }
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "st184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M971.4,806.3l0,2.4c0,0,0,0,0,0.1L971.4,806.3C971.4,806.3,971.4,806.3,971.4,806.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M971.4,806.3l0,2.4c0,0.2,0,0.4-0.1,0.5l0-2.4C971.3,806.7,971.4,806.5,971.4,806.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M971.3,806.9l0,2.4c0,0.2-0.1,0.4-0.2,0.6l0-2.4C971.2,807.3,971.3,807.1,971.3,806.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M971.1,807.4l0,2.4c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.4C970.9,807.9,971,807.7,971.1,807.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M970.7,808.1l0,2.4c-0.3,0.4-0.7,0.7-1.1,1l0-2.4C970,808.8,970.4,808.5,970.7,808.1"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "947.6,818.1 947.6,820.5 935.5,811.5 935.5,809.2  "
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "969.6,809.1 969.6,811.5 955.6,820.6 955.6,818.3  "
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M953.3,793.4c1.6-0.1,3.2,0.4,4.4,1.2l12.1,8.9c2.1,1.6,2,4.1-0.3,5.6l-14,9.1c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-12.1-8.9c-2.1-1.6-2-4.1,0.3-5.6l14-9.1C950.7,793.8,952,793.5,953.3,793.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_75_",
    className: "st8",
    d: "M955.6,818.3l0,2.4c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.4 c1.2,0.9,2.8,1.3,4.4,1.2C953.3,819.3,954.6,818.9,955.6,818.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_75_",
    style: {
      overflow: "visible"
    }
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "st185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M955.6,818.3l0,2.4c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.4C954.9,818.7,955.3,818.5,955.6,818.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M954.5,818.8l0,2.4c-0.3,0.1-0.6,0.2-1,0.3l0-2.4C953.9,819,954.2,818.9,954.5,818.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M953.5,819.1l0,2.4c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.4C953,819.2,953.3,819.2,953.5,819.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M952.7,819.3l0,2.4c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.4c0,0,0,0,0.1,0 C952.3,819.3,952.5,819.3,952.7,819.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M952,819.3l0,2.4c-0.3,0-0.5,0-0.8,0l0-2.4C951.4,819.3,951.7,819.3,952,819.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M951.2,819.3l0,2.4c-0.3,0-0.5,0-0.8-0.1l0-2.4C950.7,819.3,950.9,819.3,951.2,819.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M950.4,819.2l0,2.4c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.4C949.8,819.1,950.1,819.2,950.4,819.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M949.5,819l0,2.4c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.4C948.2,818.5,948.8,818.8,949.5,819"
  }))))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M948.5,813.4c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.7,9.1-7.4c5.9-9.2,1.1-21.1-1.7-28.1 c-1-2.5-2.3-4.8-3.6-6.9c-4-6.2-13-6.1-16.7,0.3c-1.2,2-2.3,4.2-3.3,6.6c-2.8,7-7.6,18.8-1.7,28.1 C941.8,809.7,945.3,811.9,948.5,813.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M948.5,810.7c2.8,1.2,6,1.2,8.8,0c3.2-1.4,6.7-3.6,9.1-7.1c5.9-8.9,1.1-20.4-1.7-27.1 c-2.1-4.9-5-8.9-7.7-12c-2.3-2.7-6.5-2.6-8.7,0.1c-2.5,3.1-5,7-7.1,11.9c-2.8,6.7-7.6,18.2-1.7,27.1 C941.8,807.1,945.3,809.3,948.5,810.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ball_bush"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_77_",
    className: "st8",
    d: "M650.1,970l0-2.3c0,1,0.5,1.9,1.5,2.7l0,2.3C650.6,972,650.1,971,650.1,970z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "st186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M651.6,970.4l0,2.3c-1-0.8-1.5-1.7-1.5-2.7l0-2.3C650.1,968.7,650.6,969.7,651.6,970.4"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_79_",
    className: "st8",
    d: "M686.5,967.5l0,2.3c0,1.1-0.6,2.1-1.8,2.9l0-2.3C685.9,969.6,686.5,968.6,686.5,967.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_79_",
    style: {
      overflow: "visible"
    }
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "st187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M686.5,967.5l0,2.3c0,0,0,0,0,0.1L686.5,967.5C686.5,967.6,686.5,967.5,686.5,967.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M686.5,967.6l0,2.3c0,0.2,0,0.4-0.1,0.5l0-2.3C686.5,967.9,686.5,967.8,686.5,967.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M686.4,968.1l0,2.3c0,0.2-0.1,0.4-0.2,0.6l0-2.3C686.3,968.5,686.4,968.3,686.4,968.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M686.2,968.7l0,2.3c-0.1,0.2-0.2,0.5-0.4,0.7l0-2.3C686,969.2,686.1,968.9,686.2,968.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M685.8,969.4l0,2.3c-0.3,0.4-0.7,0.7-1.1,1l0-2.3C685.2,970.1,685.5,969.7,685.8,969.4"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "663.2,979 663.2,981.3 651.6,972.7 651.6,970.4  "
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st151",
    points: "684.7,970.4 684.7,972.7 671.3,981.5 671.3,979.2  "
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M668.9,955c1.6-0.1,3.2,0.4,4.4,1.2l11.6,8.6c2.1,1.6,2,4.1-0.3,5.6l-13.4,8.8c-1,0.7-2.3,1-3.6,1.1 c-1.6,0.1-3.2-0.4-4.4-1.2l-11.6-8.6c-2.1-1.6-2-4.1,0.3-5.6l13.4-8.8C666.3,955.4,667.6,955.1,668.9,955z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_81_",
    className: "st8",
    d: "M671.3,979.2l0,2.3c-1,0.7-2.3,1-3.6,1.1c-1.6,0.1-3.2-0.4-4.4-1.2l0-2.3 c1.2,0.9,2.8,1.3,4.4,1.2C669,980.2,670.2,979.8,671.3,979.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_82_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_81_",
    style: {
      overflow: "visible"
    }
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    className: "st188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M671.3,979.2l0,2.3c-0.3,0.2-0.7,0.4-1.1,0.6l0-2.3C670.6,979.6,670.9,979.4,671.3,979.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M670.2,979.7l0,2.3c-0.3,0.1-0.6,0.2-1,0.3l0-2.3C669.5,979.9,669.8,979.8,670.2,979.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M669.2,980l0,2.3c-0.3,0.1-0.5,0.1-0.8,0.1l0-2.3C668.6,980.1,668.9,980.1,669.2,980"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M668.4,980.2l0,2.3c-0.2,0-0.5,0-0.7,0.1c0,0,0,0-0.1,0l0-2.3c0,0,0,0,0.1,0 C667.9,980.2,668.1,980.2,668.4,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M667.6,980.2l0,2.3c-0.3,0-0.5,0-0.8,0l0-2.3C667.1,980.2,667.3,980.2,667.6,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M666.8,980.2l0,2.3c-0.3,0-0.5,0-0.8-0.1l0-2.3C666.3,980.2,666.6,980.2,666.8,980.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M666,980.1l0,2.3c-0.3-0.1-0.6-0.1-0.9-0.2l0-2.3C665.4,980,665.7,980.1,666,980.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M665.1,979.9l0,2.3c-0.7-0.2-1.3-0.5-1.9-0.9l0-2.3C663.8,979.4,664.4,979.7,665.1,979.9"
  }))))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st158",
    cx: 668.4,
    cy: 960.4,
    r: 14.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st157",
    cx: 668.4,
    cy: 958.2,
    r: 14.2
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "evans"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "698.7,667 750.4,701.6 750.9,911.5 698.7,879  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "698.7,667 750.4,701.6 804.9,668.7 750.9,639.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "750.4,701.6 750.9,911.5 806.5,880.8 804.9,668.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M790.6,706.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "800.1,704.5 770.7,721.2 780.9,726.5 810.5,708.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "770.7,721.2 781.3,726.5 781.3,904.5 770.7,900.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "810.5,708.7 810.5,889.4 781.3,904.5 781.3,726.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "750.7,617.3 712,639 750.7,662.8 789.8,640.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "712,639 712,667.8 750,693 750.7,662.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "750.7,662.8 750,693 789.8,667.8 789.8,640.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "750.9,604 723.1,619.6 750.9,635.3 778.7,619.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "723.1,619.6 723.1,639.3 750.4,656 750.9,635.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "750.9,635.3 750.4,656 778.7,638.9 778.7,619.8  "
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "left-float"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M250.7,565.2L59.4,670.5c-5.2,2.8-11.6-0.8-11.6-6.5V345.9c0-2.7,1.5-5.2,3.9-6.5l182.5-101.9 c6.1-3.4,13.7,0.9,13.7,7.7l6.7,313.4C254.6,561.4,253.1,563.9,250.7,565.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M249.9,567.5L67.5,671.8c-4.9,2.8-11.1-0.7-11.1-6.4v-315c0-2.7,1.4-5.1,3.7-6.4l180.3-102.8 c5.8-3.3,13.1,0.9,13.1,7.6v312.3C253.6,563.7,252.2,566.2,249.9,567.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M254.5,569.7L72.1,673.8c-4.9,2.8-11.1-0.7-11.1-6.4V353.1c0-2.7,1.4-5.1,3.7-6.4l180.3-102.6 c5.8-3.3,13.1,0.9,13.1,7.6v311.6C258.2,566,256.8,568.4,254.5,569.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st192",
    cx: 166.9,
    cy: 463,
    r: 7.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M242.7,549.8l-157.7,90c-4.3,2.4-9.6-0.6-9.6-5.5V373.1c0-2.3,1.2-4.4,3.2-5.6l155.9-88.7 c5-2.9,11.3,0.8,11.3,6.6v258.8C245.9,546.6,244.7,548.7,242.7,549.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st193",
    cx: 182.6,
    cy: 598.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st194",
    cx: 153.2,
    cy: 310.4,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st194",
    cx: 164.4,
    cy: 304.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M93.8,389.2v20c0,2.9,3.1,4.7,5.6,3.3l38.3-21.2c1.2-0.7,1.9-1.9,1.9-3.3v-20.4c0-2.9-3.1-4.7-5.6-3.3 L95.8,386C94.6,386.6,93.8,387.9,93.8,389.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M149.7,359.6v19.6c0,3,3.2,4.9,5.8,3.4l37.9-21.1c1.2-0.7,2-2,2-3.4v-20c0-3-3.2-4.9-5.8-3.4l-37.9,21.4 C150.4,356.9,149.7,358.2,149.7,359.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st197",
    points: "93.8,437.5 93.8,606 227.3,532.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st198",
    points: "105.5,480.7 105.5,598.8 118.7,591.5 118.7,474.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "122.4,497.4 122.4,589.4 133.6,583 133.6,492.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "153.4,512.2 153.4,572.4 163.7,566.5 163.8,507.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "167.3,512.9 167.3,564.6 176.7,559.3 176.7,509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st199",
    points: "194.3,529.2 194.3,549.8 204.6,543.9 204.6,524.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st196",
    points: "208.1,509.6 208.1,542 217.6,536.7 217.6,505.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "text"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "98.7,390.1 98.7,392.1 129,375.4 128.9,373.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "99.1,395.7 99.1,397.9 129.4,381.1 129.3,378.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "154.4,361 154.4,363.2 184.7,346.4 184.6,344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "154.8,366.7 154.8,368.6 174.2,357.9 174,355.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st191",
    points: "129.4,476.1 129.4,502.6 166.9,483.9 166.9,455.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "133.6,482 133.6,485.2 155.5,473.2 155.3,469.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st201",
    points: "134,487.6 134,490.9 147.8,483.3 147.7,479.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "middle-float"
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "351.7,103.9 351.7,140.1 527,47.2 527,13.4  "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M408.6,91L408.6,91c-0.1,4.3,4.5,7.2,8.3,5.2l79.9-42.2c1.8-1,3-2.8,3-4.8v0c0.1-4.3-4.5-7.2-8.3-5.2 l-79.9,42.2C409.8,87.1,408.6,88.9,408.6,91z"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "351.7,140.1 351.7,413.2 526.9,322.7 527,47.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_83_",
    className: "st8",
    points: "347.3,418.2 351.5,139.3 526.8,47.2 522.6,326.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st204"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_85_",
    points: "526.7,47.4 351.6,139.5 347.4,418 522.6,325.9 526.7,47.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st205"
  }, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_87_",
    points: "522.6,326.1 347.3,418.2 351.5,139.3 526.8,47.2 522.6,326.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_88_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot"
    }
  }, /*#__PURE__*/React.createElement("image", {
    width: 748,
    height: 1547,
    xlinkHref: "1EC6E8101B81D981.png",
    transform: "matrix(0.24 0 0 0.24 347.3373 47.1532)",
    style: {
      overflow: "visible"
    }
  }))))))))))), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "396.3,149.1 396.3,180.2 442.8,155.5 442.8,124.2  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "396.3,194.3 396.3,225.3 442.9,200.6 442.9,169.4  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "426.4,189.3 426.4,200.4 439.4,193.7 439.4,182.4  "
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M461.2,171.5v1.6c0,1.6,1.7,2.7,3.2,1.9l23.2-12.3c0.7-0.4,1.2-1.1,1.2-1.9v-1.7c0-1.6-1.8-2.7-3.2-1.9 l-23.2,12.4C461.6,169.9,461.2,170.7,461.2,171.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M492.3,155.9l-0.1,1.9c0,1.3,1.4,2.2,2.6,1.6l12.5-6.4c0.6-0.3,0.9-0.9,1-1.5l0.1-2.1 c0-1.4-1.4-2.2-2.6-1.6l-12.5,6.6C492.7,154.7,492.4,155.3,492.3,155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M461.3,183.2l-0.1,1.9c0,1.3,1.4,2.2,2.6,1.6l12.5-6.4c0.6-0.3,0.9-0.9,1-1.5l0.1-2.1 c0-1.4-1.4-2.2-2.6-1.6l-12.5,6.6C461.7,182,461.4,182.6,461.3,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M479.6,174.2l-0.1,1.9c0,1.3,1.4,2.2,2.6,1.6l12.5-6.4c0.6-0.3,0.9-0.9,1-1.5l0.1-2.1 c0-1.4-1.4-2.2-2.6-1.6l-12.5,6.6C480,173,479.6,173.6,479.6,174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M497.3,165.2l-0.1,1.9c0,1.3,1.4,2.2,2.6,1.6l12.5-6.4c0.6-0.3,0.9-0.9,1-1.5l0.1-2.1 c0-1.4-1.4-2.2-2.6-1.6l-12.5,6.6C497.7,164,497.3,164.6,497.3,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M461.3,195.7v1.6c0,1.6,1.7,2.7,3.2,1.9l23.2-12.3c0.7-0.4,1.2-1.1,1.2-1.9v-1.7c0-1.6-1.8-2.7-3.2-1.9 l-23.2,12.4C461.7,194.1,461.3,194.9,461.3,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M492.3,179.9l-0.1,1.9c0,1.3,1.4,2.2,2.6,1.6l12.5-6.4c0.6-0.3,0.9-0.9,1-1.5l0.1-2.1 c0-1.4-1.4-2.2-2.6-1.6l-12.5,6.6C492.6,178.7,492.3,179.3,492.3,179.9z"
  }))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "396.3,243.2 396.3,274.2 442.9,249.6 442.9,218.3  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st211",
    points: "426.4,238.2 426.4,249.3 439.4,242.6 439.4,231.3  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "396.3,294.3 396.3,325.3 442.9,300.6 442.9,269.3  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "426.4,288.8 426.4,299.9 439.4,293.2 439.4,281.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st206",
    points: "396.5,339.7 396.5,370.8 443.1,346.1 443.1,314.8  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st212",
    points: "426.6,334.3 426.6,345.4 439.6,338.7 439.6,327.4  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st207",
    points: "426.4,142.9 426.4,154 439.4,147.3 439.4,136  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "363.8,165 363.8,386.5 386.7,375.2 386.7,153.5  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "461.2,115.2 461.2,124.1 508.4,99.4 508.4,90.2  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st201",
    x1: 469.2,
    y1: 195,
    x2: 516.4,
    y2: 170.3
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "461.2,143.7 461.2,148.6 494.7,131.8 494.7,126.8  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "461.3,154.8 461.3,159.6 495.7,141.8 495.7,136.7  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st214",
    points: "463.6,211.5 462.9,337.6 513.4,310.6 514,184.2  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st213",
    points: "461.2,131 461.2,135.8 494.7,119.1 494.7,114  "
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9733 -0.2294 0.2294 0.9733 -13.0419 92.6932)",
    className: "st207",
    cx: 392.2,
    cy: 102.4,
    rx: 3.4,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9733 -0.2294 0.2294 0.9733 -15.0248 89.8228)",
    className: "st215",
    cx: 378.8,
    cy: 109.5,
    rx: 3.4,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9733 -0.2294 0.2294 0.9733 -16.9453 86.8957)",
    className: "st216",
    cx: 365.3,
    cy: 116.3,
    rx: 3.4,
    ry: 3
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "right-float"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "920.4,86.9 919.6,376.3 1100.7,491.7 1100.7,215.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st201",
    points: "936.3,166.1 936.3,171.2 971.1,196.5 971.1,190.9 936.3,166.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st201",
    points: "936.3,182.3 936.3,187.5 992.2,228.1 992.2,222.5 936.3,182.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st201",
    points: "936.3,197.7 936.3,202.7 992.2,243.3 992.2,237.8 936.3,197.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st202",
    points: "919.6,46.4 920.4,86.9 1100.7,215.7 1100.7,174.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.707 -0.7072 0.7072 0.707 215.1714 707.0511)",
    className: "st207",
    cx: 960.9,
    cy: 93.8,
    rx: 3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.707 -0.7072 0.7072 0.707 216.7294 695.5928)",
    className: "st215",
    cx: 947.8,
    cy: 86.2,
    rx: 3,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.707 -0.7072 0.7072 0.707 218.5672 684.1351)",
    className: "st216",
    cx: 934.9,
    cy: 78.3,
    rx: 3,
    ry: 3.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M1068.1,165.1c2.5,1.8,3.4,4.8,2,6.8l-1.2,1.7c-1.4,1.9-4.6,2.1-7.1,0.3l-83.9-59.8c-3.7-2.7-5.1-7.2-3-10.1 v0c1.4-1.9,4.6-2.1,7.1-0.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "red_line_1_",
    className: "st217",
    points: "1086.6,303.4 1070.1,291.9 1070.1,321.4 1021.7,291.9 1020.1,342.7 980.1,320.5  980.1,359 953.2,343.2 953.2,364.9 944.8,358.7 944.8,374.6 938.9,371.1  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "blue_line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st218",
    points: "939.1,371.9 939.3,314.5 959.8,326.9 959.8,292.8 1001.1,318.9 1001.1,289.3 1036.8,310.5  1036.8,256 1060.7,272.4 1060.7,241 1088.9,256.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "green_line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st219",
    points: "934.3,369.6 934.3,361.2 973.9,384.8 973.9,336.5 1037.6,369 1037.6,343.3 1061.7,356.5  1061.7,339.7 1084.2,351.7 1084.2,329.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st220",
    points: "938.9,139.9 938.9,149.6 946.2,154.9 946.4,145.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "951.9,151.6 951.9,153.8 955.5,156.4 955.6,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st222",
    points: "959.6,154.5 959.6,164.2 967,169.5 967.1,159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st221",
    points: "973.2,167.5 973.2,169.7 976.9,172.3 976.9,170.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st223",
    points: "982.7,171.2 982.7,180.9 990.1,186.2 990.2,176.5  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerkeleytime);
export default __webpack_public_path__ + "static/media/berkeleytime.8c1ca1abd3a6a3835fd17a93c8d8ed9b.svg";
export { ForwardRef as ReactComponent };